import React, { useEffect, useState, ChangeEvent, useRef, HtmlHTMLAttributes, useMemo } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
    TextField,
    Grid,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Button,
    InputAdornment,
    IconButton,
    Typography,
    Box,
    Stack,
    Modal,
    Divider,
    SvgIcon,
    Autocomplete,
    Switch,
    CircularProgress,
    TextareaAutosize,
    Tooltip,
    Collapse,
    Paper,
    FormControlLabel,
    Checkbox,
    LinearProgress,
    RadioGroup,
    Radio,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Menu
} from "@mui/material";
import { AudioItem, VideoItem, DocumentItem, CourseDetails, GetCourseDetailsResponse } from "redux/api/types";
import MicIcon from "@mui/icons-material/Mic";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Header from "../../../components/headers/Header";
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import AddIcon from '@mui/icons-material/Add';
import '../generated_blogs.css';
import './CreateCourse.module.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as CardIcon } from '../../../assets/card_ico.svg';
import { ReactComponent as TwitterIcon } from '../../../assets/traffic_monster/icon_twitter.svg';
// import { ReactComponent as XIcon } from '../../../assets/traffic_monster/x_ico.svg';
import { ReactComponent as PinterestIcon } from '../../../assets/traffic_monster/pinterest_ico.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/traffic_monster/fb_ico.svg';
import { ReactComponent as LinkedinIcon } from '../../../assets/traffic_monster/linkedIn_ico.svg';
import { ReactComponent as StepArrowIcon } from '../../../assets/img/vector-5-2.svg';
import bulletChecked from "../../../assets/img/vector-8.svg"; // hollow bullet
import { CheckBox, FormatColorFill, Height, Widgets } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ReactComponent as VerifiedIcon } from '../../../assets/verified_ico.svg';
import { isBrowser, isMobile } from "react-device-detect";
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { usePlanDetailsMutation, useCampaignDetailsMutation } from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetpagefrocampaignMutation, useGetCnameEntriesMutation, useUpdateAutoPublishFlagMutation, useGetverifyscriptMutation, useCheckverifiedMutation } from "../../../redux/api/promptApi";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { id } from "date-fns/locale";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { IPlanDetail } from "../../../redux/api/types";
import { useLazyGetProductQuery } from '../../../redux/api/productApi';
import { useAppSelector } from '../../../redux/store';
import { ReactComponent as Twitterico } from '../../../assets/traffic_monster/twitter__ico.svg';
import { ReactComponent as Pinterestico } from '../../../assets/traffic_monster/pinterest__ico.svg';
import { ReactComponent as Fbico } from '../../../assets/traffic_monster/fb__ico.svg';
import { ReactComponent as Linkedinico } from '../../../assets/traffic_monster/linkedin__ico.svg';
import axios from 'axios';
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from '@mui/icons-material/Info';
import YouTubeIcon from '@mui/icons-material/YouTube';
import youtubeIco1 from '../../../assets/traffic_monster/youtubeIco_1.png'
import { upload } from "@testing-library/user-event/dist/upload";
import ProgressBar from "@ramonak/react-progress-bar";
import { setCookie, getCookie, removeCookie } from '../../../utils/storageUtils';
import { urPK } from "@mui/x-date-pickers";
import { useAppDispatch } from "../../../redux/store";
import { logout } from "redux/features/userSlice";
import ocesha_logo from '../../../assets/ocesha_images/ocesha_logo.png';
import { ReactComponent as BlogsIco } from '../../../assets/ocesha_images/blogs_ico.svg';
import { ReactComponent as VideoIco } from '../../../assets/ocesha_images/video_ico.svg';
import { ReactComponent as AudioIco } from '../../../assets/ocesha_images/audio_ico.svg';
import { ReactComponent as ImagesIco } from '../../../assets/ocesha_images/images_ico.svg';
import { ReactComponent as ClipIco } from '../../../assets/ocesha_images/clip_ico.svg';
import { ReactComponent as TeamIco } from '../../../assets/ocesha_images/team_ico.svg';
import { ReactComponent as IntegrationIco } from '../../../assets/ocesha_images/integration_ico.svg';
import { ReactComponent as UpgradeIco } from '../../../assets/ocesha_images/upgrade_ico.svg';
import { ReactComponent as BillingIco } from '../../../assets/ocesha_images/billing_ico.svg';
import { ReactComponent as SettingsIco } from '../../../assets/ocesha_images/settings_ico.svg';
import { ReactComponent as HelpIco } from '../../../assets/ocesha_images/help_ico.svg';
import { ReactComponent as LogoutIco } from '../../../assets/ocesha_images/logout_ico.svg';
import { ReactComponent as DashboardIco } from '../../../assets/ocesha_images/dashboard_ico.svg';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import uploadIcon from "../../../assets/img/upload-cloud.svg";
import checkGreen from "../../../assets/podcast_monster/vector-7.svg"; // green check
import audioIcon from "../../../assets/img/icon-audio.svg";
import videoIcon from "../../../assets/img/icon-video.svg";
import docIcon from "../../../assets/img/icon-doc.svg";
import youtubeIcon from "../../../assets/img/icon-youtube.svg";
import linkIcon from "../../../assets/img/icon-link.svg";
import textIcon from "../../../assets/img/icon-text.svg";
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import SendIcon from "@mui/icons-material/Send";
import { ReactComponent as EditIco } from '../../../assets/podcast_monster/edit_ico.svg';
import RohanImg from '../../../assets/podcast_monster/rohan_png.png';
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { ReactComponent as CloudIcon } from '../../../assets/podcast_monster/cloud.svg';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { TTSButton } from "../../../components/TTSPlayer";
import { speakText, stopTTS } from "../../../redux/features/ttsSlice";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import TitleIcon from '@mui/icons-material/Title';
import { useTTSQueue } from "hooks/useTTSQueue";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckIcon from "@mui/icons-material/Check";
import BoltIcon from '@mui/icons-material/Bolt';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { saveVoiceSample } from "utils/digitalTwinVoice";

<StepArrowIcon
    style={{
        width: 20,
        height: 20,
        margin: '0 12px',
        opacity: 0.6,
    }}
/>

const ONBOARDING_QUESTIONS = [
    {
        id: 1,
        text: "Tell me your name and a bit about who you are.",
        isCompleted: true,
    },
    {
        id: 2,
        text: "What topics do you speak or teach about?",
        isCompleted: true,
    },
    {
        id: 3,
        text: "Who do you help or who is your audience?",
        isCompleted: false,
    },
    {
        id: 4,
        text: "What results do you help people achieve?",
        isCompleted: false,
    },
    {
        id: 5,
        text: "What type of courses would you love to create if it were easy?",
        isCompleted: false,
    },
];

const COURSE_STEPS = [
    {
        number: "01",
        title: "Share your\nExpertise",
        isActive: true,
    },
    {
        number: "02",
        title: "Upload Content\nto Train",
        isActive: false,
    },
    {
        number: "03",
        title: "Choose your\nCourse Topic",
        isActive: false,
    },
    {
        number: "04",
        title: "Generate your\nCourse",
        isActive: false,
    },
];

interface ErrorResponse {
    error: {
        status: number;
        data: {
            detail: string;
        };
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: '#D0D5DD',
        color: 'lightblack',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const getUploadContentType = (filePath: string) => {
    const ext = filePath.split(".").pop()?.toLowerCase();

    const audioExts = ["mp3", "wav", "aac", "ogg", "flac", "m4a"];
    const videoExts = ["mp4", "mov", "avi", "mkv", "webm"];

    if (audioExts.includes(ext || "")) return "audio";
    if (videoExts.includes(ext || "")) return "video";

    return null;
};


const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white', // Set background color for odd rows to white
        color: 'black', // Set text color for odd rows to black
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#F2F6FA', // Set background color for even rows to gray
        color: 'darkslategray',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const HeaderCell = styled('div')(({ theme }) => ({
    color: '#626F86',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));

const DataCell = styled('div')(({ theme }) => ({
    color: '#344054',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));


type UploadedItem =
    | string
    | {
        label: string;
        deletable: boolean;
        index?: number;
    };

interface UploadedGroupProps {
    icon: string;
    title: string;
    items: UploadedItem[];
    onDelete?: (index: number) => void;
}


type ProcessingStatus = "pending" | "in_progress" | "complete" | "failed";
type ProcessingContentType = "audio" | "video" | "youtube_urls" | "web_urls";

export const updateProcessingStatus = async (params: {
    content_type: ProcessingContentType;
    identifier: string;
    progress: number;
    status: ProcessingStatus;
}) => {
    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const courseId = localStorage.getItem("course_id");

    if (!courseId) throw new Error("Course ID missing");

    return axios.post(`${apiUrl}/api/prompts/update_course_progress`, {
        course_id: courseId,
        ...params,
    });
};


const updateAllProcessingStatuses = async (course: any) => {
    try {
        // ---- AUDIO ----
        if (Array.isArray(course.audio)) {
            for (const audio of course.audio) {
                await updateProcessingStatus({
                    content_type: "audio",
                    identifier: audio.path,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        // ---- VIDEO ----
        if (Array.isArray(course.video)) {
            for (const video of course.video) {
                await updateProcessingStatus({
                    content_type: "video",
                    identifier: video.path,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        // ---- YOUTUBE URLS ----
        if (Array.isArray(course.youtube_urls)) {
            for (const item of course.youtube_urls) {
                await updateProcessingStatus({
                    content_type: "youtube_urls",
                    identifier: item.url,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        // ---- WEB URLS ----
        if (Array.isArray(course.web_urls)) {
            for (const item of course.web_urls) {
                await updateProcessingStatus({
                    content_type: "web_urls",
                    identifier: item.url,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        console.log("All processing statuses initialized");
    } catch (err) {
        console.error("Failed to update processing status", err);
    }
};



const UploadedGroup = ({ icon, title, items, onDelete }: UploadedGroupProps) => (
    <Box mb={2.5}>
        <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
            <Box component="img" src={icon} sx={{ width: 18 }} />
            <Typography color="white" fontWeight={'normal'}>
                {title}
            </Typography>
        </Stack>

        {items.map((item, i) => {
            const label = typeof item === "string" ? item : item.label;
            const deletable = typeof item !== "string" && item.deletable;
            const index = typeof item !== "string" ? item.index : undefined;

            return (
                <Stack
                    key={i}
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    ml={4}
                    mb={0.5}
                >
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background: "#22C55E",
                        }}
                    />

                    <Typography color="#D9D9D9" fontSize="14px" sx={{ flex: 1, maxHeight: "160px", overflowY: "auto", pr: 1, lineHeight: 1.4 }}>
                        {label}
                    </Typography>

                    {/* ✅ Delete only if allowed */}
                    {deletable && onDelete && typeof index === "number" && (
                        <IconButton
                            size="small"
                            onClick={() => onDelete(index)}
                        >
                            <DeleteOutlineIcon sx={{ color: "#EF4444" }} />
                        </IconButton>
                    )}
                </Stack>
            );
        })}
    </Box>
);






const New_Course_4 = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const { FromEdit } = location.state || {};
    const { campIdFrEdit } = location.state || {};
    const { subscriptionFromCampList } = location.state || {};
    const { subscriptionTH } = location.state || {};
    const { mode } = location.state || {};
    const FromSignUp = location.state?.FromSignUp || '';
    const [selectedPreference, setSelectedPreference] = useState(0);
    const [isToneUpdating, setIsToneUpdating] = useState(false);

    //console.log(subscriptionTH);
    //console.log(mode);
    const [sourceUrl, setSourceUrl] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? localStorage.getItem('UrlfromLanding') || '' : '');
    const [blogcount, setBlogCount] = useState<any>(1);
    const [sourceYoutubeUrl, setSourceYoutubeUrl] = useState<any>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? localStorage.getItem('YoutubeUrlfromLanding') || '' : '');
    const [sourceText, setSourceText] = useState<string>('');
    const [videoTag, setVideoTag] = useState<string>(sourceYoutubeUrl || '');
    const [twitterUrl, settwitterUrl] = useState<string>('');
    const [fbUrl, setfbUrl] = useState<string>('');
    const [pintrestUrl, setPintrestUrl] = useState<string>('');
    const [linkedinUrl, setLinkedinUrl] = useState<string>('');
    const [ctaLabel, setCtaLabel] = useState<string>('');
    const [ctaLink, setCtaLink] = useState<string>('');
    const [isEditing, setIsEditing] = useState(false);
    const [userInput, setUserInput] = useState(
        "My name is Sarah Jackson and i am a professional speech therapy trainer...",
    );
    const [introInput, setIntroInput] = useState(
        "Do you have any questions ask me...",
    );
    const [expertise, setExpertise] = useState(
        'My name is Sarah Jackson and I am a professional speech therapy trainer...'
    );
    const [isRecording, setIsRecording] = useState(false);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunksRef = useRef<BlobPart[]>([]);

    // Chat + Audio state
    const [questionText, setQuestionText] = useState("");
    const [chatMessages, setChatMessages] = useState<any[]>([]);
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [lastBotText, setLastBotText] = useState<string>("");
    const prevTextRef = useRef("");
    const chatScrollRef = useRef<HTMLDivElement | null>(null);

    //const audioRef = useRef<HTMLAudioElement | null>(null);
    const hasFetched = useRef(false);

    const [isListening, setIsListening] = useState(false);
    const [isListening1, setIsListening1] = useState(false);
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const recognitionRef = useRef<any>(null);
    const recognitionRef1 = useRef<any>(null);

    const [campaignName, setCampaignName] = useState<string>('');
    const [urlPrefix, setUrlPrefix] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? 'youtubeid' : (localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? 'https://' : 'upload');
    const [expanded, setExpanded] = useState(true);
    const [expanded1, setExpanded1] = useState(true);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [expanded4, setExpanded4] = useState(false);
    const [expanded5, setExpanded5] = useState(false);
    const [expanded6, setExpanded6] = useState(false);
    const [expanded7, setExpanded7] = useState(false);
    const [expanded8, setExpanded8] = useState(false);
    const [expanded9, setExpanded9] = useState(false);
    const [expanded10, setExpanded10] = useState(false);
    const [expanded11, setExpanded11] = useState(false);
    const [expanded12, setExpanded12] = useState(false);
    const [expanded14, setExpanded14] = useState(false);
    const [expanded15, setExpanded15] = useState(false);
    const [expanded13, setExpanded13] = useState(false);
    const [planDetails, setPlanDetails] = useState<any>();
    const [campDetails, setCampDetails] = useState<any>();
    const [defaultPlanDetails, setDefaultPlanDetails] = useState<any>();
    const [campaignId, setCampaignId] = useState<any>();
    const [userDetails, setUserDetails] = useState<any>();
    const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);
    const [paymentOption, setPaymentOption] = useState<any>();
    const [paymentOptYearlyCal, setPaymentOptYearlyCal] = useState<any>();
    const paymentSectionRef = useRef<HTMLDivElement>(null);
    const getcnameEntriesRef = useRef<HTMLDivElement>(null);
    const getVerifyScript = useRef<HTMLDivElement>(null);
    const [autoPublish, setAutopublish] = useState<any>(false);
    const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
    const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
    const [competitorSearch, setCompetitorSearch] = useState<any>(false);
    const [limitPublish, setLimitPublish] = useState<any>(true);
    const [socialMediaUrlPublish, setSocialMediaUrlPublish] = useState<any>();
    const [addtags, setAddTags] = useState<any>(true);
    const [externalLinks, setExternalLinks] = useState<any>(true);
    const [toc, setToc] = useState<any>(true);
    const [capturleads, setCapturLeads] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [newsletter, setNewsLetter] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [twitternbutton, setTwitternButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [fbbutton, setFbButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [pintrestbutton, setPintrestButton] = useState<any>(true);
    const [linkedinbutton, setLinkedinButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [video, setVideo] = useState<any>(!!planDetails?.embed_youtube_video);
    const [useOwnDomain, setUseOwnDomain] = useState<any>(false);
    const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
    const [openGetPagesuccessModal, setOpenGetPageSuccessModal] = useState<boolean>(false);
    const [confirmCancelSubscription, setConfirmCancelSubscription] = useState<boolean>(false);
    const [cnameRecords, setCnameRecords] = useState<any>();
    const [cnameDomainName, setCnameDomainName] = useState<any>();
    const [isLoadingCnameRec, setIsLoadingCnameRec] = useState<boolean>(false);
    const getpageRunref = useRef(false);
    const [script, setScript] = useState<any>();
    const [verifyCheck, setVerifyCheck] = useState<any>();
    const [period, getPeriodState] = useState("monthly");
    const [createCampaignMutation] = useCreateCampaignMutation();
    const user_email = localStorage.getItem('user_email') || getCookie('user_email') || '';
    const [isUpdateLoader, setIsUpdateLoader] = useState<boolean>(false);
    const [selectedSubscriptionLevel, setSelectedSubscriptionLevel] = useState<string>('');
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const emptyText = (label: string) => [`${label} not uploaded`];

    const [uploadedDuration, setUploadedDuration] = useState<string>("00:00");
    const [uploadedSize, setUploadedSize] = useState<string>("");


    const [getProduct, getState] = useState<any>(); //useLazyGetProductQuery();
    const [plans, setPlans] = useState<IPlanDetail[]>([
        {
            user: 1,
            plan_name: "",
            total_wishes: 0,
            price: "",
            period: "",
            product_id: "",
            price_id: "",
            subscription_level: "",
            feature: [],
            contracts: 0,
            type: "",
            button_text: "",
            save: ''
        },
    ]);
    const [productModule, setProductModule] = useState("");
    const genieSelector = useAppSelector((state) => state.genieState);

    const [createCheckoutSession, checkoutState] = useLazyCreateCheckoutSessionQuery();
    const [getUserDetailsMutation] = useGetUserDetailsMutation();

    // console.log('is this from edit=>', FromEdit);
    const [getuserPlanDetails] = usePlanDetailsMutation();
    const [getuserCampDetails] = useCampaignDetailsMutation();
    const [getPageforCampaign] = useGetpagefrocampaignMutation();
    const [getCnameEntriesMutation] = useGetCnameEntriesMutation();
    const [getverifyscript] = useGetverifyscriptMutation();
    const [getcheckverified] = useCheckverifiedMutation();
    const [updateAutoPublishCheckMutation] = useUpdateAutoPublishFlagMutation();


    const [userImage, setUserImage] = useState<File | null>(null);
    const [userImageUrl, setUserImageUrl] = useState('');
    const [socialUrl, setSocialUrl] = useState('');
    const [name, setName] = useState('');
    const [useAsDefault, setUseAsDefault] = useState(false);
    const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
    const [campaignListMutation] = useCampaignListMutation();
    const [campaignDatas, setCampaignDatas] = useState<any>();
    const [couponCode, setCouponCode] = useState<string>('');
    const [successCancelSubscription, setSuccessCancelSubscription] = useState(false);
    const [podcastoryoutubeurl, setPodcastOrYoutubeUrl] = useState('');
    const [selectedSection, setSelectedSection] = useState('websiteSection');
    const [uploadVideo, setUploadVideo] = useState('');
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [uploadedvideopath, setUploadedvideopath] = useState('');
    const [fileDuaration, setfileDuaration] = useState<any>();
    const [getPageError, setGetPageError] = useState(false);
    const [loaderProgress, setLoaderProgress] = useState<any>(4);
    const [userBusinessText, setUserBusinessText] = useState('');
    const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
    const [course, setCourse] = useState<CourseDetails | null>(null);
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState<any>(
        <Typography fontSize="18px">
            <b>Analyzing Your Content...</b>
            <br />
            We’re using AI Agents to read through your content, analyze your content, and will suggest some ideas that we can write about
        </Typography>
    );

    const [deleteArgs, setDeleteArgs] = useState<{
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text";
        index: number;
    } | null>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deletePayload, setDeletePayload] = useState<{
        contentType: string;
        index: number;
    } | null>(null);
    const [intervaltime, setIntervalTime] = useState(4000);
    const handleCouponTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCouponCode(event.target.value);
    };
    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [helperPopup, setHelperPopup] = useState<boolean>(false);
    const [isScrapcheckloading, setIsScrapcheckloading] = useState<boolean>(false);
    const [activeItem, setActiveItem] = useState(localStorage.getItem('activeItem') || 'dashboard');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [topics, setTopics] = useState<any>();
    const [topicsList, setTopicsList] = useState<boolean>(false);
    const [selectedTopic, setSelectedTopic] = useState<any>();
    const [keywords, setKeywords] = useState<any>();
    const [keywordsList, setKeywordsList] = useState<boolean>(false);
    const [selectedKeyword, setSelectedKeyword] = useState<any>();
    const [isKeywordLoader, setIsKeywordLoader] = useState<boolean>(false);
    const [uploadAnchorEl, setUploadAnchorEl] =
        React.useState<null | HTMLElement>(null);
    const autoAddRef = React.useRef(false);

    const openUploadMenu = Boolean(uploadAnchorEl);

    const handleUploadMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
        setUploadAnchorEl(e.currentTarget);
    };

    const handleUploadMenuClose = () => {
        setUploadAnchorEl(null);
    };

    const [currentAudioType, setCurrentAudioType] = useState<"intro" | "question" | null>(null);

    const {
        playText,
        pause,
        resume,
        stop,
        stopAll,
        seek,
        isPlaying,
        currentIndex,
        audioRef,
        isMuted,       // ✅ add
        setIsMuted,
    } = useTTSQueue();

    
    const location_audio = useLocation();
    
    useEffect(() => {

        stopAllAudio();

    }, [location_audio.pathname]);

    useEffect(() => {
        // On every page load, nuke any audio leaking from a previous route
        stopAll();
        document.querySelectorAll("audio").forEach(a => {
          try { a.pause(); a.currentTime = 0; a.src = ""; } catch {}
        });
        return () => {
          stopAll();   // and again on the way out
        };
    }, []);
    

    useEffect(() => {
        (window as any).isMutedGlobal = isMuted;
        stopAllAudio();
        if (audioRef.current) {
            audioRef.current.muted = isMuted;
        }
    }, [isMuted]);


    //console.log("localStorage......");
    //console.log(localStorage)

    const hasAnyContent = () => {
        return Boolean(
            course?.audio?.length ||
            course?.video?.length ||
            course?.documents?.length ||
            course?.youtube_urls?.length ||
            course?.web_urls?.length ||
            course?.text_documents?.length
        );
    };

    const requestDelete = (
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text",
        index: number
    ) => {
        setDeleteArgs({ contentType, index });
        setConfirmOpen(true);
    };

    const handleFilesUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files?.length) return;

        const file = e.target.files[0];
        setUploadedFiles([file]);

        const media = document.createElement(
            file.type.startsWith("audio") ? "audio" : "video"
        );

        media.preload = "metadata";
        media.src = URL.createObjectURL(file);

        media.onloadedmetadata = () => {
            URL.revokeObjectURL(media.src);

            const duration = media.duration;
            const minutes = Math.floor(duration / 60);
            const seconds = Math.floor(duration % 60);

            setUploadedDuration(
                `${minutes}:${seconds.toString().padStart(2, "0")}`
            );
        };
    };


    const startRecording = async () => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("mediaDevices not supported");
            return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        const mediaRecorder = new MediaRecorder(stream, {
            mimeType: "audio/webm",
        });

        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                audioChunksRef.current.push(event.data);
            }
        };

        mediaRecorder.onstop = sendAudioToBackend;

        mediaRecorder.start();
        mediaRecorderRef.current = mediaRecorder;
        setIsRecording(true);
    };

    const stopRecording = () => {
        mediaRecorderRef.current?.stop();
        setIsRecording(false);
    };




    const sendAudioToBackend = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
            type: "audio/webm",
        });

        await saveVoiceSample(audioBlob);

        const formData = new FormData();
        formData.append("audio", audioBlob, "speech.webm");

        try {
            const res = await fetch(`${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE}/speech_to_text`, {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            // assuming FastAPI returns: { text: "..." }
            //setExpertise((prev) => `${prev} ${data.text}`.trim());
            setQuestionText((prev) => `${prev} ${data.text}`.trim());
        } catch (err) {
            console.error("Speech upload failed", err);
        }
    };

    const stripHtml = (html: string) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    const formatAIResponse = (text: string) => {
        if (!text) return "";

        let formatted = text;

        formatted = formatted.replace(/\*{2,}/g, "");
        formatted = formatted.replace(/#{1,}/g, "");
        formatted = formatted.replace(/^\* (.+)$/gm, "• $1");

        formatted = formatted.replace(
            /(?:^|\n)(• .*(?:\n• .*)*)/g,
            (match) => {
                const items = match
                    .trim()
                    .split("\n")
                    .map((line) => `<li>${line.replace(/^• /, "")}</li>`)
                    .join("");
                return `<ul>${items}</ul>`;
            }
        );

        formatted = formatted.replace(/^(.+):$/gm, "<h3>$1</h3>");

        formatted = formatted.replace(
            /^(?!<h3>|<ul>|<li>|<\/ul>)(.+)$/gm,
            "<p>$1</p>"
        );

        formatted = formatted.replace(/<p>\s*<\/p>/g, "");

        return formatted;
    };

    const getChatBotResponse = async (query: string) => {
        if (!query.trim()) return;

        // add user message
        setChatMessages((prev) => [...prev, { role: "user", text: query }]);

        setQuestionText("");
        setIsChatLoading(true);

        try {
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const res = await axios.post(`${apiUrl}/api/prompts/chat_answer`, {
                courseid: "6a14a3fb195a2644a8352676",
                query,
                chapter: ""
            });

            let answer = res?.data?.response || "No response";

            // cleanup formatting (same as view-course)
            answer = answer.replace(/\*{2,}/g, "");
            answer = answer.replace(/#{1,}/g, "");
            answer = answer.replace(/^\* (.+)$/gm, "• $1");

            const formatted = formatAIResponse(answer);

            setChatMessages((prev) => [
                ...prev,
                {
                    role: "bot",
                    text: formatted,
                },
            ]);

            // store clean text for TTS
            const cleanText = stripHtml(answer);
            setLastBotText(cleanText);

        } catch (err) {
            console.error("Chat error", err);
        } finally {
            setIsChatLoading(false);
        }
    };

    useEffect(() => {
        if (!lastBotText) return;

        if (prevTextRef.current === lastBotText) return;

        prevTextRef.current = lastBotText;

        stop(); // stop previous audio
        setCurrentAudioType(null);
        playText(lastBotText); //  new TTS
    }, [lastBotText]);

    // useEffect(() => {
    //     if (!lastBotText) return;

    //     // Prevent duplicate autoplay
    //     if (prevTextRef.current === lastBotText) return;

    //     // Mark as played
    //     prevTextRef.current = lastBotText;

    //     // STOP any existing TTS FIRST
    //     dispatch(stopTTS());

    //     // Small delay ensures clean reset (important)
    //     const timer = setTimeout(() => {
    //         dispatch(
    //             speakText({
    //                 text: lastBotText,
    //                 voice: "default.wav",
    //                 id: "global-tts",
    //             })
    //         );
    //     }, 150);

    //     return () => clearTimeout(timer);
    // }, [lastBotText, dispatch]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };
    const handleExpandClick2 = () => {
        if (planDetails?.plan_name === 'ENTERPRISE') {
            setExpanded2(!expanded2);
        } else {
            setUpgradeModal(true);
        }
    }
    const handleExpandClick3 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded3(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded3(false);
                return false;
            } */
        if (planDetails?.white_label_options === true) {
            setExpanded3(!expanded3);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick4 = () => {
        setExpanded4(!expanded4)
    }

    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    }

    const handleExpandClick6 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded6(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded6(false);
                return false;
            } */
        setExpanded6(!expanded6);
    }

    const handleExpandClick7 = () => {

        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {

            setExpanded7(false);
            return false;
        }
        if (planDetails)

            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded7(false);
                return false;
            } */

        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded7(!expanded7);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick8 = () => {
        /*  if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
             || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
             || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
             || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
             setExpanded8(false);
             return false;
         }
         if (planDetails)
             if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                 setExpanded8(false);
                 return false;
             } */
        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded8(!expanded8);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick9 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded9(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded9(false);
                return false;
            } */
        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded9(!expanded9);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    }

    const handleExpandClick11 = () => {
        if (planDetails?.embed_youtube_video === true) {
            setExpanded11(!expanded11);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    }

    const handleExpandClick14 = () => {
        setExpanded14(!expanded14);
    }

    const handleExpandClick15 = () => {
        setExpanded15(!expanded15);
    }



    /* useEffect(() => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];

                // Only take FINAL result
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                setQuestionText((prev) => (prev + " " + finalTranscript).trim());
                setUserBusinessText((prev) => (prev + " " + finalTranscript).trim());
            }
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        recognition.onerror = () => {
            setIsListening(false);
        };

        recognitionRef.current = recognition;
    }, []);

    useEffect(() => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];

                // Only take FINAL result
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                // setQuestionText((prev) => (prev + " " + finalTranscript).trim());
                setUserBusinessText((prev) => (prev + " " + finalTranscript).trim());
            }
        };

        recognition.onend = () => {
            setIsListening1(false);
        };

        recognition.onerror = () => {
            setIsListening1(false);
        };

        recognitionRef1.current = recognition;
    }, []); */

    const createSpeechRecognition = (
        onFinalTranscript: (text: string) => void,
        setListening: (val: boolean) => void
    ) => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return null;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                onFinalTranscript(finalTranscript);
            }
        };

        recognition.onend = () => setListening(false);
        recognition.onerror = () => setListening(false);

        return recognition;
    };

    useEffect(() => {
        recognitionRef.current = createSpeechRecognition(
            (text) => {
                setQuestionText((prev) => (prev + " " + text).trim());
                // setUserBusinessText((prev) => (prev + " " + text).trim());
            },
            setIsListening
        );
    }, []);

    useEffect(() => {
        recognitionRef1.current = createSpeechRecognition(
            (text) => {
                setUserBusinessText((prev) => (prev + " " + text).trim());
            },
            setIsListening1
        );
    }, []);


    useEffect(() => {

        const campaignRes = async () => {
            try {
                const response = await campaignListMutation({ email: user_email || getCookie('user_email') || "" });
                if ('data' in response) {
                    setCampaignDatas(response.data);
                    console.log('campaign list response=>', response.data)
                } else {
                    console.error('Error fetching campaign List:', response.error);
                }
            } catch (error) {
                console.log('Error fetching campaign List:', error);
            }
        }
        campaignRes();
    }, [user_email])

    useEffect(() => {

        localStorage.removeItem('publishingCampId');
    }, []);

    /* const handleMicClick = async () => {
        if (!recognitionRef.current) return;

        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
            return;
        }

        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            // THIS LINE IS REQUIRED
            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef.current.start();
            setIsListening(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    };

    const handleMicClick1 = async () => {
        if (!recognitionRef1.current) return;

        if (isListening1) {
            recognitionRef1.current.stop();
            setIsListening1(false);
            return;
        }

        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            // THIS LINE IS REQUIRED
            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef1.current.start();
            setIsListening1(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    }; */

    const handleMic = async (
        recognitionRef: React.RefObject<any>,
        isListening: boolean,
        setIsListening: (val: boolean) => void
    ) => {
        if (!recognitionRef.current) return;

        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
            return;
        }

        try {
            if (!navigator.mediaDevices?.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef.current.start();
            setIsListening(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    };

    const handleEditClick = () => {
        textareaRef.current?.focus();
    };


    const validateCampaignName = () => {
        /* if(campaignName === ''){
            toast.error('Please fill your Campaign Name!');
            return false;
        } */

        const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
        if (isDuplicate) {
            toast.error('Duplicate campaign Name. Please choose a different name!');
            return false;
        }
        return true;
    }

    const youtubeMatch = videoTag?.match(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    //console.log('plan details =>', plans);
    const handleCreateCampaignClickold = async () => {
        if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') {
            if (video && !videoTag) {
                toast.error('Please enter YouTube video URL on video section');
            } else if (video && !youtubeMatch) {
                toast.error('Please enter only YouTube video URL');

            } else {
                autoPublishCheck(campIdFrEdit);
                handleUpdateSetting(campIdFrEdit);
                localStorage.removeItem('ChangepayMode');
                localStorage.removeItem('IdChangingMode');
            }
            // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
            // if(planDetails?.owndomain === '1'){

            // }
        }
        else {
            // debugger;
            // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
            if (campaignName === '' /* || sourceUrl === '' || !paymentOption || (!limitPublish && !autoPublish) */) {
                // toast.error(`Please fill all the * required fields!`);
                toast.error('Please fill your Campaign Name!');
            } /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ else if (
                (urlPrefix === 'text' && sourceText === '') ||
                (urlPrefix !== 'text' && sourceUrl === '')
            ) {
                toast.error('Please fill your Source Page URL/TEXT');
            }
            /* else if (!paymentOption) {
                toast.error('Please choose the payment option!');
                return;
            }  *//* else if (!autoPublish) {
                toast.error('Please fill the autopublish blog!');
            } */ else if (video && !videoTag) {
                toast.error('Please enter YouTube video URL on video section');
            } else if (video && !youtubeMatch) {
                toast.error('Please enter only YouTube video URL');

            }
            /* else if (!name) {
                toast.error('Please fill the required field on author section!');
            } */
            else {
                try {
                    var tmpurl = urlPrefix === 'https://' ? (document.getElementById('sourceurl') as HTMLInputElement)?.value : '';
                    if (tmpurl.indexOf("http") < 0) tmpurl = urlPrefix === 'https://' ? "https://" + tmpurl : '';

                    const finalurl = tmpurl;
                    const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    );

                    setIsLoadingGetPage(true);
                    const videoid = youtubeMatch ? youtubeMatch[1] : '';

                    const response = await createCampaignMutation({ campaign_name: campaignName, url: finalurl ? encodeURIComponent(finalurl) : '', email: user_email || getCookie('user_email') || "", sourcemode: urlPrefix === 'text' ? 'text' : 'url', videoid: videoid ? videoid : '', product_desc: sourceText ? encodeURIComponent(sourceText) : '' });
                    console.log("response==" + response);


                    if ('data' in response) {

                        console.log('created campaign result=>', response.data);//getting campaign id here
                        if (response.data.status === 'success') {
                            setCampaignId(response.data.campaign_id);
                            autoPublishCheck(response.data.campaign_id);
                            handleUpdateSetting(response.data.campaign_id);
                            handleVerifyCheckClick(response.data.campaign_id);
                            toast.success(response.data.msg);
                            setIsLoadingGetPage(false);
                            localStorage.setItem('fromNewcampaign', 'true');
                            handleCheckout(response.data.campaign_id);
                            // setOpenPaymentInstructModal(true);
                        } else if (response.data.status === 'failed') {
                            setIsLoadingGetPage(false);
                            toast.error(response.data.msg);
                        }

                    }
                    else {
                        const errorMessage = (response?.error as any)?.data?.detail as string | undefined;

                        toast.error(errorMessage);
                        setIsLoadingGetPage(false);
                        //window.location.reload();
                    }
                } catch (error) {

                    setIsLoadingGetPage(false);
                    console.log('Error creating campaign:', error);
                }
            }
        }
    }


    const handleTextChange = (event: any) => {
        let inputText = event.target.value;
        setUserBusinessText(inputText);
    };

    useEffect(() => {

        let intervalId: any;
        if (isloadingGetPage && loaderProgress < 100) {
            intervalId = setInterval(() => {
                setLoaderProgress((prevProgress: any) => {
                    const newProgress = prevProgress + 2;
                    return newProgress >= 98 ? 98 : newProgress;
                });
            }, intervaltime);
        }

        return () => clearInterval(intervalId);
    }, [isloadingGetPage, loaderProgress]);


    /*** code for celery starts */
    interface TaskStatusResponse {
        state: "pending" | "done" | "error";
        result?: any;
        message?: string;
    }

    interface ScrapPageResponse {
        task_id: string;
    }

    const ContentSection = ({
        title,
        items,
        emptyText,
        renderItem,
    }: {
        title: string;
        items: any[];
        emptyText: string;
        renderItem: (item: any, idx: number) => JSX.Element;
    }) => (
        <div className="mb-6">
            <h3 className="text-white font-semibold mb-2">{title}</h3>

            {items.length === 0 ? (
                <p className="text-gray-400 text-sm">{emptyText}</p>
            ) : (
                <ul className="space-y-1">
                    {items.map(renderItem)}
                </ul>
            )}
        </div>
    );

    // Utility to sleep for some ms
    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    const fetchCourse = async () => {
        try {

            const courseId = localStorage.getItem("course_id");
            if (!courseId) return;
            setLoading(true);
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const { data } = await axios.post<GetCourseDetailsResponse>(
                `${apiUrl}/api/prompts/get_course_details`,
                { course_id: courseId }
            );
            console.log(data.result);
            setCourse(data.result);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) return;



        fetchCourse();
    }, []);

    const waitForTaskResult = async (taskId: string, apiUrl: string): Promise<any> => {
        const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;

        while (true) {
            const { data } = await axios.get<TaskStatusResponse>(statusUrl);

            if (data.state === "done") {
                return data.result;
            } else if (data.state === "error") {
                throw new Error(data.message || "Task failed");
            }

            await sleep(2000); // poll every 2 seconds
        }
    };

    /*** code for celery ends */

    const handlescrappage = async (url: string) => {
        setIsLoadingGetPage(true);
        setLoaderProgress(4);
        // setIsScrapcheckloading(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            // const response = await axios.get(
            //     `${apiUrl}/api/prompts/scrap_page?url=${url}`,
            // );

            // Step 1: start the task
            const { data } = await axios.get<ScrapPageResponse>(`${apiUrl}/api/prompts/scrap_page?url=${encodeURIComponent(url)}`);
            const taskId = data.task_id;

            // Step 2: poll until done
            const response = await waitForTaskResult(taskId, apiUrl);


            console.log('scrap_page response=>', response);
            if (response.result === 'failed') {
                setIsLoadingGetPage(false);
                toast.error(response.data);
            } else {
                handleCreateCampaignClick();
            }
        } catch (error) {
            console.log(error);
        } finally {
            // setIsScrapcheckloading(false);
            setLoaderProgress(15);
        }
    }

    useEffect(() => {
        console.log(campaignId);
    }, [campaignId]);

    const stopAllAudio = () => {
        stopAll();
        // Stop intro audio
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }

        // Stop question audio
        /*if (expertiseAudioRef.current) {
          expertiseAudioRef.current.pause();
          expertiseAudioRef.current.currentTime = 0;
        }*/

        // Stop TTS
        //dispatch(stopTTS());
    };

    const handleUpdateTone = async () => {
        try {
            setIsToneUpdating(true);

            const selectedTone = toneOptions[selectedPreference];

            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const response = await axios.post(
                `${apiUrl}/api/prompts/update_tone`,
                {},
                {
                    params: {
                        user_email: user_email,
                        tone: selectedTone,
                    },
                    headers: {
                        accept: "application/json",
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message || "Tone updated successfully");

                localStorage.setItem("selectedTone", selectedTone);

            } else {
                toast.error("Failed to update tone");
            }
        } catch (error) {
            console.error("Tone update failed:", error);
            toast.error("Something went wrong");
        } finally {
            setIsToneUpdating(false);
        }
    };

    const handleCreateCourseStep2 = async () => {
        stopAllAudio();

        await handleUpdateTone();

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

        const response = await axios.post(
            `${apiUrl}/api/prompts/process_migrate_videos_to_podcasts_trigger`,
            {},
            {
                params: {
                    user_email: user_email
                },
                headers: {
                    accept: "application/json",
                },
            }
        );


        
        const response1 = await axios.post(
            `${apiUrl}/api/prompts/process_update_skillset_bio_trigger`,
            {},
            {
                params: {
                    user_email: user_email
                },
                headers: {
                    accept: "application/json",
                },
            }
        );

        localStorage.setItem("activeItem", "onboardingcomplete");
        navigate("/codegenie/onboarding-complete");

    }

    const handleCreateCourseStepPrevious = async () => {
        resetUploadState();

        stopAllAudio();
        //Save and then move to next screen
        navigate('/codegenie/new-course', { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });

    }

    const handleCreateCampaignClick = async () => {


        if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') {
            /*  if (video && !videoTag) {
                 toast.error('Please enter YouTube video URL on video section');
             } else if (video && !youtubeMatch) {
                 toast.error('Please enter only YouTube video URL');

             } else { */
            autoPublishCheck(campIdFrEdit);
            handleUpdateSetting(campIdFrEdit);
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            // }
            // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
            // if(planDetails?.owndomain === '1'){

            // }
        }
        else {
            // debugger;
            // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
           /*  if (campaignName === '') {
                toast.error('Please fill your Campaign Name!');
            }  *//* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } *//*  else */ if (
                (urlPrefix === 'text' && userBusinessText === '') ||
                (urlPrefix === 'https://' && sourceUrl === '') ||
                (urlPrefix === 'youtubeid' && sourceYoutubeUrl === '') ||
                (urlPrefix === 'upload' && !uploadedvideopath)
            ) {
                toast.error('Please fill any one of the source type!');
            } else if ((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) {
                setUpgradeModal(true);
                // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
            } else if ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) {
                setUpgradeModal(true);
                // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
            }

            else {
                try {
                    var tmpurl = urlPrefix === 'youtubeid' ? (document.getElementById('sourceyoutubeurl') as HTMLInputElement)?.value : '';
                    if (tmpurl.indexOf("http") < 0) tmpurl = urlPrefix === 'youtubeid' ? "https://" + tmpurl : '';

                    const finalurl = tmpurl;
                    /* const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    ); */
                    const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/
                    );
                    const videoid = youtubeMatch ? youtubeMatch[1] : '';

                } catch (error) {

                    setIsLoadingGetPage(false);
                    console.log('Error creating campaign:', error);
                }
            }
        }
    }

    useEffect(() => {

        if (FromEdit === 'startEditing') {
            getVerifyingScript(campIdFrEdit);
            handleVerifyCheckClick(campIdFrEdit);
            cnameRec(campIdFrEdit);
        }
    }, []);

    const cnameRec = async (campIdFrEdit: string) => {
        try {
            const response = await getCnameEntriesMutation({ email: user_email || getCookie('user_email') || "", campaignid: campIdFrEdit || '' });
            if ('data' in response) {

                setCnameDomainName(response.data);
                setCnameRecords(response.data.cnamerecords);
            }
        } catch (error) {
            console.log('Error fetching dns record:', error);
        }
    }

    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email || getCookie('user_email') || '', campaignid: /* campIdFrEdit || localStorage.getItem('IdChangingMode') ||  */'' });
            if ('data' in response) {

                setPlanDetails(response.data.data);
                //console.log('plan details***=>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }



    useEffect(() => {

        // if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' || successCancelSubscription === true) {
        fetchPlanDatas();
        //console.log(planDetails);
        // }
    }, []);

    const fetchCampDatas = async () => {
        try {
            const response = await getuserCampDetails({ campaignid: campIdFrEdit || /* localStorage.getItem('IdChangingMode') || */ '' });
            if ('data' in response) {

                setCampDetails(response.data.data);

            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {

        if (FromEdit === 'startEditing') {
            fetchCampDatas();
        }
    }, []);


    const autoPublishCheck = async (id: string) => {
        setIsUpdateLoader(true);
        try {
            const validVideoTag = videoTag?.trim() || campDetails?.videotag?.trim() || '';
            const response = await updateAutoPublishCheckMutation({ campaign_id: id, autopublish: autoPublish ? 1 : 0, threeblogperday: limitPublish ? 1 : 0, addtags: addtags ? 1 : 0, capturleads: capturleads ? 1 : 0, twitterurl: planDetails?.twitterurl || twitterUrl || '', fburl: planDetails?.fburl || fbUrl || '', pintresturl: planDetails?.pintresturl || pintrestUrl || '', linkedinurl: planDetails?.linkedinurl || linkedinUrl || '', newsletter: newsletter ? 1 : 0, twitternbutton: twitternbutton ? 1 : 0, fbbutton: fbbutton ? 1 : 0, pintrestbutton: /* pintrestbutton ? 1 : */ 0, linkedinbutton: linkedinbutton ? 1 : 0, video: video ? 1 : 0, owndomain: useOwnDomain ? 1 : 0, cta_lable: ctaLabel ? encodeURIComponent(ctaLabel) : planDetails?.cta_lable ? encodeURIComponent(planDetails?.cta_lable) : 'Learn More', cta_link: ctaLink ? encodeURIComponent(ctaLink) : campDetails?.cta_link ? encodeURIComponent(campDetails?.cta_link) : sourceUrl, videotag: encodeURIComponent(validVideoTag), iframe: 1, publish_to_ocesha: publishToOcesha ? 1 : 0, publish_to_code_genie: publishToCodegenie ? 1 : 0, competetor_search: competitorSearch ? 1 : 0 });

            if (FromEdit === 'startEditing') {
                if ('data' in response) {


                    // toast.success(response.data.msg);
                    if (FromEdit === 'startEditing') {
                        toast.success('Blog settings updated successfully!');
                    } else {
                        toast.success(response.data.msg);
                    }
                }
            }
        } catch (error) {
            console.log('Error:', error);
        } finally {
            setIsUpdateLoader(false);
        }
    }

    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({ email: user_email || getCookie('user_email') || '', filter: '', start_date: '', end_date: '' });

            if ('data' in response) {

                // const datas = response.data.data;
                setUserDetails(response.data.data);

            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {

        fetchData();
    }, []);

    const handleCheckout = async (campaignId: string) => {

        let referral_param = localStorage.getItem("referral_param");
        localStorage.removeItem("referral_param");
        /* let couponcode = localStorage.getItem("couponcode");
        localStorage.removeItem("couponcode"); */

        try {
            const response = await createCheckoutSession({ "emailid": user_email || getCookie('user_email') || "", "username": userDetails?.first_name, "subscription_level": selectedSubscriptionLevel/* paymentOption === '$0/mo.' ? 'level_0' : paymentOption === '$14/mo.' ? 'level_1' : paymentOption === '$39/mo.' ? 'level_2' : paymentOption === '$99/mo.' ? 'level_3' : (paymentOption === '$0/mo.' && period === 'yearly') ? 'level_0y' : paymentOption === '$82.5/mo.' ? 'level_4' : paymentOption === '$165.8/mo.' ? 'level_5' : paymentOption === '$249.16/mo.' ? 'level_6' : '' */, "referral_param": referral_param || "", "couponcode": couponCode ?? "", "mode": '', campaignid: campaignId || '', "from_page": 'campaign', return_domain: '' });

            if (response.data.message == "Checkout url created") {
                // Assuming response contains the checkout URL
                const checkoutUrl = response.data.checkout_url;

                // Redirect to the Stripe checkout page
                window.location.href = checkoutUrl;
            }
            else if (response.data.error) {
                const errorMessage = response.data.error;
                if (errorMessage.includes('This promotion code cannot be redeemed because the associated customer has prior transactions.')) {
                    toast.error('Coupon code already applied');
                } else if (errorMessage.includes('This coupon cannot be redeemed because it does not apply to anything in this order.')) {
                    toast.error('Invalid Coupon code');
                } else {
                    toast.error('Invalid Coupon code');
                }
            }
            /* else {
                console.log('checkout res=>', response);
                toast.error("Something went wrong, checkout url not created");
            } */

        }
        catch (e) {
            alert(e);
            console.log(e);
        }
    }

    const data = [
        { heading: 'QUANTITY', value: '1' },
        { heading: 'PLAN TYPE', value: period === 'monthly' ? 'Monthly' : 'Yearly' },
        { heading: 'PLAN NAME', value: planDetails ? (planDetails.subscription_level === 'level_0' || planDetails.subscription_level === 'level_0y' ? 'Starter' : planDetails.subscription_level === 'level_1' || planDetails.subscription_level === 'level_4' ? 'Basic' : planDetails.subscription_level === 'level_2' || planDetails.subscription_level === 'level_5' ? 'Pro' : planDetails.subscription_level === 'level_3' || planDetails.subscription_level === 'level_6' ? 'Traffic Hacker' : '') : selectedSubscriptionLevel ? (selectedSubscriptionLevel === 'level_0' || selectedSubscriptionLevel === 'level_0y' ? 'Starter' : selectedSubscriptionLevel === 'level_1' || selectedSubscriptionLevel === 'level_4' ? 'Basic' : selectedSubscriptionLevel === 'level_2' || selectedSubscriptionLevel === 'level_5' ? 'Pro' : selectedSubscriptionLevel === 'level_3' || selectedSubscriptionLevel === 'level_6' ? 'Traffic Hacker' : '') : '' },
        { heading: 'TOTAL', value: planDetails ? (planDetails?.subscription_level === 'level_0' ? '$49/mo.' : planDetails?.subscription_level === 'level_1' ? '$99/mo.' : planDetails?.subscription_level === 'level_2' ? '$199/mo.' : planDetails?.subscription_level === 'level_3' ? '$299/mo.' : planDetails?.subscription_level === 'level_0y' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : planDetails?.subscription_level === 'level_4' ? '$' + (82.5 * 12).toFixed(1) + '/yr.'/* '$82.5/mo.' */ : planDetails?.subscription_level === 'level_5' ? '$' + (165.8 * 12).toFixed(1) + '/yr.'/* '$165.8/mo.' */ : planDetails?.subscription_level === 'level_6' ? '$' + (249.16 * 12).toFixed(1) + '/yr.'/* '$249.16/mo.' */ : '') : /* paymentOption */paymentOptYearlyCal },
        // { heading: 'PAYMENT', value: <Button variant="contained" sx={{ color: '#fff' }} onClick={handleCheckout}>Pay Now</Button> }
    ];


    const handledropdownChange = (event: any) => {
        setSelectedSection(event.target.value);
    }

    const handleSourceUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }

        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceUrl(urlVal);
        localStorage.setItem('sourceurl', urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }



    }

    const handleblogscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setBlogCount(value);
        } else {
            toast.error('Please enter numeric value!');
        }
    }

    const handleSourceYoutubeUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }

        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceYoutubeUrl(urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }


        // localStorage.setItem('sourceurl', urlVal);
    }

    const handleSourceTextChange = (event: any) => {
        let textVal = event.target.value;
        setSourceText(textVal);
        localStorage.setItem('sourcetext', textVal);
    }

    const handlePodcastUrlChange = (event: any) => {
        let podcastVal = event.target.value;
        setPodcastOrYoutubeUrl(podcastVal);
        localStorage.setItem('podcastUrl', podcastVal);
    }


    useEffect(() => {

        if (sourceYoutubeUrl) {
            setVideoTag(sourceYoutubeUrl);
        }
    }, [sourceYoutubeUrl]);

    const handlevideotag = (event: any) => {
        let videotagg = event.target.value.trim();;
        setVideoTag(videotagg);
        /* if (sourceYoutubeUrl) {
            setSourceYoutubeUrl(videotagg);
        } else */ if (campDetails) {
            setCampDetails({
                ...campDetails,
                videotag: videotagg
            })
        }
        localStorage.setItem('videoTag', videotagg);
    }

    const handletwitterUrlChange = (event: any) => {
        let urlVal = event.target.value;
        settwitterUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitterurl: urlVal
            });
        }
        localStorage.setItem('twitterurl', urlVal);
    }

    const handlefbUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setfbUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fburl: urlVal
            });
        }
        localStorage.setItem('fburl', urlVal);
    }

    const handlepintrestUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setPintrestUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                pintresturl: urlVal
            });
        }
        localStorage.setItem('pintresturl', urlVal);
    }

    const handleCtaLabelChange = (event: any) => {
        let label = event.target.value;
        setCtaLabel(label);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_lable: label
            });
        }
    }

    const handleCtaLinkChange = (event: any) => {
        let link = event.target.value;
        setCtaLink(link);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_link: link
            });
        }
    }

    const handlelinkedinUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setLinkedinUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinurl: urlVal
            });
        }
        localStorage.setItem('linkedinurl', urlVal);
    }


    const handlepaymentOptions = (value: any, subscription_level: any) => {
        // const payment_Option = event?.target.value;
        setPaymentOption(value);
        setSelectedSubscriptionLevel(subscription_level);

        setPaymentOptYearlyCal(value === '$48.8/mo.' && period === 'yearly' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : value === '$82.5/mo.' ? '$' + (82.5 * 12).toFixed(1) + '/yr.' : value === '$165.8/mo.' ? '$' + (165.8 * 12).toFixed(1) + '/yr.' : value === '$249.16/mo.' ? '$' + (249.16 * 12).toFixed(1) + '/yr.' : value)
        localStorage.setItem('paymentOption', value);
        localStorage.setItem('PaymentSubscription', subscription_level);

        if (subscription_level == 'level_0' || subscription_level == 'level_0y' || subscription_level == 'level_1'
            || subscription_level == 'level_2' || subscription_level == 'level_4' || subscription_level == 'level_5') {

            setExpanded3(false);
            setExpanded6(false);
            setExpanded7(false);
            setExpanded8(false);
            setExpanded9(false);

            setSocialMediaUrlPublish(false)
            setCapturLeads(false);
            setNewsLetter(false);
            setTwitternButton(false);
            setFbButton(false);
            setPintrestButton(false);
            setLinkedinButton(false);

            settwitterUrl('');
            setfbUrl('');
            setPintrestUrl('');
            setLinkedinUrl('');
        }
        else {

            setCapturLeads(true);
            setNewsLetter(true);
            setTwitternButton(true);
            setFbButton(true);
            setPintrestButton(true);
            setLinkedinButton(true);
        }

    }

    const paymentSubscription = localStorage.getItem('PaymentSubscription') || '';



    const handleAutoPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setAutopublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                autopublish: isChecked
            });
        }
        localStorage.setItem('autoPublish', isChecked.toString());
    };


    const handlePublishToOceshaChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToOcesha(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_ocesha: isChecked
            });
        }
        localStorage.setItem('publish_to_ocesha', isChecked.toString());
    };

    const handleCompetitorSearchChange = (event: any) => {
        const isChecked = event.target.checked;
        setCompetitorSearch(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                competetor_search: isChecked
            });
        }
        localStorage.setItem('competitor_search', isChecked.toString());
    };

    const handlePublishToCodegenieChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToCodegenie(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_code_genie: isChecked
            });
        }
        localStorage.setItem('publish_to_code_genie', isChecked.toString());
    };

    const handlelimitPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setLimitPublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                threeblogperday: isChecked
            });
        }
        localStorage.setItem('limitPublish', isChecked.toString());
    };

    const handlesocialMediaUrlPublishChange = (event: any) => {
        /* if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                return false;
            } */
        const isChecked = event.target.checked;
        setSocialMediaUrlPublish(isChecked);
        if (campDetails) {
            // Update planDetails if it exists (you can add specific updates if needed)
            setCampDetails({
                ...campDetails,
                // Here you can add any relevant updates to planDetails based on isChecked
                // For example:
                socialMediaUrlPublish: isChecked
            });
        }
        localStorage.setItem('smUrlpublish', isChecked.toString());
    };

    const handleaddtagsChange = (event: any) => {
        const isChecked = event.target.checked;
        setAddTags(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                addtags: isChecked
            });
        }
        localStorage.setItem('addTags', isChecked.toString());
    };

    const handletocChange = (event: any) => {
        const isChecked = event.target.checked;
        setToc(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                toc: isChecked
            });
        }
        localStorage.setItem('toc', isChecked.toString());
    };

    const handleexternalLinksChange = (event: any) => {
        const isChecked = event.target.checked;
        setExternalLinks(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                external_links: isChecked
            });
        }
        localStorage.setItem('externalLinks', isChecked.toString());
    };

    const handlecapturleadsChange = (event: any) => {
        const isChecked = event.target.checked;
        setCapturLeads(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                capturleads: isChecked
            });
        }
        localStorage.setItem('captureLeads', isChecked.toString());
    };

    const handlenewsletterChange = (event: any) => {
        const isChecked = event.target.checked;
        setNewsLetter(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                newsletter: isChecked
            });
        }
        localStorage.setItem('newsLetter', isChecked.toString());
    };

    const handletwitterBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setTwitternButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitternbutton: isChecked
            });
        }
        localStorage.setItem('twitterBtn', isChecked.toString());
    };

    const handlefbBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setFbButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fbbutton: isChecked
            });
        }
        localStorage.setItem('fbBtn', isChecked.toString());
    };

    const handlepintrestBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setPintrestButton(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                pintrestbutton: isChecked
            });
        }
        localStorage.setItem('pintrestBtn', isChecked.toString());
    };

    const handlelinkedinBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setLinkedinButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinbutton: isChecked
            });
        }
        localStorage.setItem('linkedinBtn', isChecked.toString());
    };

    const handlevideoChange = (event: any) => {
        const isChecked = event.target.checked;
        setVideo(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                video: isChecked
            });
        }
        localStorage.setItem('video', isChecked.toString());
    };

    const handleOwnDomainChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseOwnDomain(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                owndomain: isChecked
            });
        }
        localStorage.setItem('owndomain', isChecked.toString());
    };

    const handleAuthorUseDefaultChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseAsDefault(isChecked);
        // if (userDetails) {
        //     setUserDetails({
        //         ...userDetails,
        //         blog_default: isChecked
        //     })
        // }
        // else
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                use_as_default: isChecked
            });
        } else if (userDetails) {
            setUserDetails({
                ...userDetails,
                blog_default: isChecked
            });
        }
        localStorage.setItem('authorDefaultCheck', isChecked.toString());
    }

    const handleModalPayNowClick = () => {
        setOpenPaymentInstructModal(false);
        setExpanded(true);
        setTimeout(() => {
            paymentSectionRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    const campaignIdfromsuccess = localStorage.getItem('campaignid');

    const handleTopicConfirmation = async (topic: any, keywordCount: any, campId: any) => {
        setIsLoadingGetPage(true);
        setLoaderProgress(8);
        setLoadingText(
            <Typography fontSize="18px">
                <b>Researching Keywords</b>
                <br />
                We’re using AI Agents to research and suggest the best keywords to get traffic for your blog
            </Typography>
        );
        setTopicsList(false);
        setIsKeywordLoader(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            // const response = await axios.get(
            //     `${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`,
            // );

            // Step 1: start the task
            const { data } = await axios.get<ScrapPageResponse>(`${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`);
            const taskId = data.task_id;

            // Step 2: poll until done
            const response2 = await waitForTaskResult(taskId, apiUrl);


            if (response2.result) {
                setLoaderProgress(100);
                await new Promise(resolve => setTimeout(resolve, 500));
                setIsLoadingGetPage(false);
                setKeywords(response2.data);
                setKeywordsList(true);
                setTopicsList(false);
            }
        } catch (error) {
            console.log('Error fetching keywords=>', error);
        } finally {
            setIsKeywordLoader(false);
            setLoaderProgress(40);
            setIsLoadingGetPage(false);
        }
    }

    const handleGetPageforCampaign = async (userEmail: any, campaignid: any, topic: any, keyword: any) => {
        setKeywordsList(false);
        setIsLoadingGetPage(true);
        setLoaderProgress(8);
        // if (!campIdFrEdit) {
        setLoadingText(
            <Typography fontSize="18px">
                <b>Writing Blog Content</b>
                <br />
                Our AI is now writing your blog(s) based on your content, topic, and keyword.  We will use Google EEAT standard that will help with your blog ranking well in Google Search.
            </Typography>
        );
        setIntervalTime(4000);
        // setIsLoadingGetPage(true);
        // }
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

            //const response = await getPageforCampaign({ email: userEmail || getCookie('user_email') || "", campaign_id: campaignid || '', topic: topic, keywords: keyword });

            // Step 1: Call the mutation to start the task
            const { data: taskResponse }: any = await getPageforCampaign({
                email: userEmail || getCookie("user_email") || "",
                campaign_id: campaignid || "",
                topic,
                keywords: keyword,
            });

            const taskId = taskResponse.task_id;

            // Step 2: Poll until task is done or failed
            const response = await waitForTaskResult(taskId, apiUrl);


            if ('data' in response) {
                //console.log('getpagecampaign=>', response.data.result);


                if (response.result === 'success' && !campIdFrEdit) {
                    setLoaderProgress(100);
                    setTimeout(() => {
                        localStorage.setItem('activeItem', 'blogs');
                        setIsLoadingGetPage(false);
                        navigate('/codegenie/generated-blogs', { state: { FromCampaign: campaignIdfromsuccess } });
                        // setOpenGetPageSuccessModal(true);
                    }, 1000);
                } else if (response.result === 'failure') {
                    setGetPageError(true);
                    toast.error(response.message);
                }
            }
            else {
                const errorMessage = (response?.error as any)?.data?.detail as string | undefined;
                toast.error(errorMessage);
                setIsLoadingGetPage(false);
            }
        } catch (error) {
            toast.error('Error generating blogs');
            setIsLoadingGetPage(false);
            console.log('Error generating blogs:', error);
        }
    }



    const handleGetPageModalClose = async () => {
        setOpenGetPageSuccessModal(false);
        localStorage.setItem('activeItem', 'blogs');
        navigate('/codegenie/generated-blogs', { state: { FromCampaign: campaignIdfromsuccess } });
        // setExpanded3(true);
        // setTimeout(() => {
        //    getcnameEntriesRef?.current?.scrollIntoView({ behavior: 'smooth' });
        // }, 300);
        setIsLoadingCnameRec(true);

    }

    const getVerifyingScript = async (campaignId: string) => {
        // setExpanded4(true);
        /*  setTimeout(() => {
             getVerifyScript?.current?.scrollIntoView({ behavior: 'smooth' });
         }, 300); */
        try {
            const response = await getverifyscript({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId || ''/* campaignId ? campaignId : campaignIdfromsuccess || '' */ });
            if ('data' in response) {

                setScript(response.data.script);
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleVerifyCheckClick = async (campaignId: string) => {
        try {
            const response = await getcheckverified({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId/* localStorage.getItem('campaignid') */ || '' });
            if ('data' in response) {

                setVerifyCheck(response.data.status);
                localStorage.removeItem('campaignid');
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageUrl = URL.createObjectURL(file);
            setUserImage(file/* e.target.files[0] */);
            setUserImageUrl(imageUrl);

            return () => URL.revokeObjectURL(imageUrl);
        }
    };

    const handleUpdateSetting = async (campaignId: string) => {
        // e.preventDefault();
        setIsUpdateLoader(true);
        let formData = new FormData();

        // let isFormValid = validateForm();
        // if (isFormValid) {
        //   setIsLoading(true);

        formData.append('name', name != "" && name != undefined ? name : planDetails?.name === undefined ? userDetails?.first_name : planDetails.name/* planDetails?.name || '' */);
        formData.append('campaignid', campaignId);
        if (userImage) {
            formData.append('user_image', userImage);
        }


        const element = document.getElementById("authurl") as HTMLInputElement;

        if (element.value) {
            formData.append('social_url', element.value);
        }
        else {
            formData.append('social_url', socialUrl);
        }



        const element1 = document.getElementById("usedefault") as HTMLInputElement;
        if (element1.checked) {
            formData.append('use_as_default', '1');
        }
        else {
            formData.append('use_as_default', useAsDefault ? '1' : '0');
        }


        //   formData.append('blog_default', blogDefault ? '1' : '0');
        //   formData.append('email', useremail);
        //   formData.append('auto_publish', isChecked ? `${isChecked}` : "0");
        /* if (!name || !campaignId) {
            toast.error('Please fill the required field on author section!');
        } */
        // else {
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + '/api/prompts/updateAuthorinfo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status == "success") {
                //   toast.success(response.data.message);
                //   setIsLoading(false);
                const randomNumber = Math.random();
                setUserImageUrl(response.data.user_image + "?" + randomNumber);
                /* if (FromEdit === 'startEditing') {
                    toast.success(response.data.message);
                } */
            }
            else {
                toast.error("Somethng went wrong..")
                //   setIsLoading(false);
            }

        } catch (error) {
            console.error('Error updating author settings:', error);
            // setIsLoading(false);
        } finally {
            setIsUpdateLoader(false);
        }
        // }

        // }

    };

    useEffect(() => {
        if (campDetails?.social_url)
            setSocialUrl(campDetails?.social_url);

        if (campDetails?.name)
            setName(campDetails?.name);



        if (campDetails?.use_as_default == 1)
            setUseAsDefault(true);

    }, [campDetails]);

    useEffect(() => {

        if (!campDetails?.social_url && userDetails?.social_url)
            setSocialUrl(userDetails?.social_url);

        if (!name)
            setName(userDetails?.first_name);

    }, [userDetails]);

    useEffect(() => {

        const storedCampaignName = localStorage.getItem('campaignName');
        if (storedCampaignName) {
            setCampaignName(storedCampaignName);
        }

        const storedAuthorName = localStorage.getItem('Authorname');
        if (storedAuthorName) {
            setName(storedAuthorName);
        }

        const storedAuthorurl = localStorage.getItem('Authorurl');
        if (storedAuthorurl) {
            setSocialUrl(storedAuthorurl);
        }

        const storedSourceUrl = localStorage.getItem('sourceurl');
        if (storedSourceUrl) {
            setSourceUrl(storedSourceUrl);
        }

        const storedSourceText = localStorage.getItem('sourcetext');
        if (storedSourceText) {
            setSourceText(storedSourceText);
        }

        const storedPodcastUrl = localStorage.getItem('podcastUrl');
        if (storedPodcastUrl) {
            setPodcastOrYoutubeUrl(storedPodcastUrl);
        }

        const storedtwitterUrl = localStorage.getItem('twitterurl');
        if (storedtwitterUrl) {
            settwitterUrl(storedtwitterUrl);
        }

        const storedFBUrl = localStorage.getItem('fburl');
        if (storedFBUrl) {
            setfbUrl(storedFBUrl);
        }

        const storedpintrestUrl = localStorage.getItem('pintresturl');
        if (storedpintrestUrl) {
            setPintrestUrl(storedpintrestUrl);
        }

        const storedLinkedinUrl = localStorage.getItem('linkedinurl');
        if (storedLinkedinUrl) {
            setLinkedinUrl(storedLinkedinUrl);
        }

        const payment_opt = localStorage.getItem('paymentOption');
        if (payment_opt) {
            setPaymentOption(payment_opt);
        }

        const storedAutoPublish = localStorage.getItem('autoPublish');
        if (storedAutoPublish !== null) {
            setAutopublish(storedAutoPublish === 'true');
        }

        const storedLimitPublish = localStorage.getItem('limitPublish');
        if (storedLimitPublish !== null) {
            setLimitPublish(storedLimitPublish === 'true');
        }

        const storedsocialMediaurlsPublish = localStorage.getItem('smUrlpublish');
        if (storedsocialMediaurlsPublish !== null) {
            setSocialMediaUrlPublish(storedsocialMediaurlsPublish === 'true');
        }

        const storedAddTags = localStorage.getItem('addTags');
        if (storedAddTags !== null) {
            setAddTags(storedAddTags === 'true');
        }

        const storedcaptureLeads = localStorage.getItem('captureLeads');
        if (storedcaptureLeads !== null) {
            setCapturLeads(storedcaptureLeads === 'true');
        }

        const storednewsLetter = localStorage.getItem('newsLetter');
        if (storednewsLetter !== null) {
            setNewsLetter(storednewsLetter === 'true');
        }

        const storedtwitterBtn = localStorage.getItem('twitterBtn');
        if (storedtwitterBtn !== null) {
            setTwitternButton(storedtwitterBtn === 'true');
        }

        const storedfbBtn = localStorage.getItem('fbBtn');
        if (storedfbBtn !== null) {
            setFbButton(storedfbBtn === 'true');
        }

        const storedpintrestBtn = localStorage.getItem('pintrestBtn');
        if (storedpintrestBtn !== null) {
            setPintrestButton(storedpintrestBtn === 'true');
        }

        const storedlinkedinBtn = localStorage.getItem('linkedinBtn');
        if (storedlinkedinBtn !== null) {
            setLinkedinButton(storedlinkedinBtn === 'true');
        }

        const storedvideo = localStorage.getItem('video');
        if (storedvideo !== null) {
            setVideo(storedvideo === 'true');
        }

        const storedAuthorDefCheck = localStorage.getItem('authorDefaultCheck');
        if (storedAuthorDefCheck !== null) {
            setUseAsDefault(storedAuthorDefCheck === 'true');
        }
    }, []);

    const handleCampaignNameChange = (event: any) => {
        const newName = event.target.value;
        if (newName === planDetails?.product_name) {
            toast.error('Already campaign name exist!');
        } else {
            setCampaignName(newName);
            if (planDetails) {
                setPlanDetails({
                    ...planDetails,
                    product_name: newName
                });
            }
            localStorage.setItem('campaignName', newName);
        }
    };

    const handleAuthorNameChange = (event: any) => {
        const newName = event.target.value;
        setName(newName);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                name: newName
            });
        }
        else if (userDetails) {
            setUserDetails({
                ...userDetails,
                name: newName
            });
        }
        localStorage.setItem('Authorname', newName);
    }

    const handleAuthorUrlChange = (event: any) => {
        const newUrl = event.target.value;

        setSocialUrl(newUrl);
        // if (userDetails) {
        //     setUserDetails({
        //         ...userDetails,
        //         social_url: newUrl
        //     })
        // }
        // else
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                social_url: newUrl
            });
        }
        else if (userDetails) {
            setUserDetails({
                ...userDetails,
                social_url: newUrl
            });
        }
        localStorage.setItem('Authorurl', newUrl);
    }

    const handleCopyName = (name: string) => {
        navigator.clipboard.writeText(name).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleCopyscript = (script: string) => {
        navigator.clipboard.writeText(script).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleCopyVal = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //oast.success('Copied to Clipboard!');
        })
    }

    const placeholderText = 'https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s';

    const code_snippet = script/* `<!- Traffic Monster tag (gtag.js) --> <script async src=https://www.googletagmanage EGRK3ZCMNX"></script> <script> window.dataLayer =
window.dataLayer || []; function gtag() {dataLayer.push(arguments) i) gtag('is' new Date gtag('config', 'G-EGRKзZCMNX');` */;

    /* const handleShare = (url: any) => {
        window.open(url, '_blank');
    };

    const shareOnTwitter = () => {
        handleShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnPinterest = () => {
        handleShare(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnFacebook = () => {
        handleShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnLinkedin = () => {
        handleShare(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`);
        handleShare(`https://www.linkedin.com/sharing/share-offsite/url=${encodeURIComponent(window.location.href)}`);

    }; */

    useEffect(() => {

        setUserImageUrl(planDetails?.user_image || campDetails?.user_image);
    }, [planDetails]);

    const NormallyValArray = [period == "monthly" ? '' : 'Normally $14/mo.', period == "monthly" ? '' : 'Normally $49/mo.', period == "monthly" ? '' : 'Normally $99/mo.', period == "monthly" ? '' : 'Normally $149/mo.'];

    const handleChangePayMethodClick = async () => {
        localStorage.setItem('ChangepayMode', 'true');
        localStorage.setItem('IdChangingMode', campIdFrEdit);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/change_payment_method?email=${user_email}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status === 'success') {
                window.open(response.data.portal_url, '_blank');
            }
        } catch (error) {
            console.log('Error changing payment method', error);
        }
    }

    const handleCancelSubscriptionClick = async () => {
        setCancellingLoader(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/Cancel_Subscription?campaign_id=${campIdFrEdit}`, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            });
            if (response.data.status === 'success') {
                setSuccessCancelSubscription(true);
                setConfirmCancelSubscription(false);
                toast.success('Cancelled Subscription!');
            }
        } catch (error) {
            toast.error('Error cancelling subscription');
            console.log('Error cancelling subscription', error);
        } finally {
            setCancellingLoader(false);
        }
    }

    const currentlocationurl = window.location.origin;
    const addtoMyblogscodeSnippet =
        `<iframe src="${currentlocationurl}/blogs?campaignid=${campIdFrEdit}&header=off" height="600" width="900" title="Iframe Example"></iframe>`;

    const handleCopyCodeSnippet = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleuploadvideoChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const apiUrl: string = process.env.REACT_APP_UPLOAD_SERVER_ENDPOINT || "";
        const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB
        const CONCURRENCY = 20;
        const RETRIES = 3;

        // UI state
        if (urlPrefix === "word" || urlPrefix === "pdf") {
            setLoadingText("Uploading your document...");
        } else {
            setLoadingText("Uploading your media...");
        }
        setUploadVideo(file.name);
        setIsLoadingGetPage(true);
        setLoaderProgress(0);
        //setLoaderProgress(5);

        // helpers
        const splitIntoChunks = (f: File, chunkSize: number) => {
            const parts: { index: number; start: number; end: number; blob: Blob }[] = [];
            let idx = 0;
            for (let start = 0; start < f.size; start += chunkSize) {
                const end = Math.min(start + chunkSize, f.size);
                parts.push({ index: idx++, start, end, blob: f.slice(start, end) });
            }
            return parts;
        };

        const initUpload = async (filename: string, totalSize: number, chunkSize: number) => {
            const form = new FormData();
            form.append("filename", filename);
            form.append("total_size", String(totalSize));
            form.append("chunk_size", String(chunkSize));
            const resp = await axios.post(`${apiUrl}/upload/init`, form);
            return resp.data as { upload_id: string; total_chunks: number; chunk_size: number };
        };

        const getStatus = async (uploadId: string) => {
            try {
                const resp = await axios.get(`${apiUrl}/upload/${uploadId}/status`);
                return resp.data as { uploaded: number[] };
            } catch (err) {
                return { uploaded: [] };
            }
        };

        const uploadChunk = async (uploadId: string, index: number, blob: Blob) => {
            // form field names: index, chunk (server expects chunk)
            const form = new FormData();
            form.append("index", String(index));
            form.append("chunk", blob, `chunk_${index}`);
            return axios.post(`${apiUrl}/upload/${uploadId}/chunk`, form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 0, // disable timeout for big chunk uploads
            });
        };

        const completeUpload = async (uploadId: string) => {
            const resp = await axios.post(`${apiUrl}/upload/${uploadId}/complete`);

            return resp.data;
        };

        try {
            // 1) init (or reuse existing upload_id for this filename if present)
            //let uploadId: string | null = localStorage.getItem(`upload_id:${file.name}`) || null;
            let uploadId: string | null = null;
            let initResp: { upload_id: string; total_chunks: number; chunk_size: number } | null = null;
            if (uploadId) {
                // verify status
                const status = await getStatus(uploadId);
                // if status empty, re-init
                if (!status || !Array.isArray(status.uploaded)) {
                    uploadId = null;
                    localStorage.removeItem(`upload_id:${file.name}`);
                }
            }

            if (!uploadId) {
                initResp = await initUpload(file.name, file.size, CHUNK_SIZE);

                uploadId = initResp.upload_id;
                    // save for resume
                localStorage.setItem(`upload_id:${file.name}`, uploadId);
            } else {
                // fetch metadata from server - we still need total_chunks/chunk_size
                // try to call /upload/{uploadId}/status for chunk_size info or re-init
                const status = await getStatus(uploadId);
                // if we don't have chunk size, re-init
                initResp = {
                    upload_id: uploadId,
                    total_chunks: Math.ceil(file.size / CHUNK_SIZE),
                    chunk_size: CHUNK_SIZE,
                };
            }

            //setLoaderProgress(10);

            // 2) build chunk list and skip already-uploaded
            const chunks = splitIntoChunks(file, CHUNK_SIZE);
            const statusResp = await getStatus(uploadId);
            const uploadedSet = new Set<number>((statusResp.uploaded || []).map((n: number) => Number(n)));
            const pending = chunks.filter((c) => !uploadedSet.has(c.index));

            if (pending.length === 0) {

                // nothing to upload, just complete
                const comp = await completeUpload(uploadId);

                setUploadedvideopath(comp.data || comp); // adapt to your response
                toast.success("File Uploaded Successfully!");
                setLoaderProgress(100);
                setTimeout(() => setIsLoadingGetPage(false), 1000);
                return;
            }

            // 3) upload chunks with concurrency and retries
            let uploadedBytes = (chunks.length - pending.length) * CHUNK_SIZE;
            const totalBytes = file.size;
            setLoaderProgress(Math.round((uploadedBytes / totalBytes) * 100));

            // worker pool: process pending in batches of CONCURRENCY
            const queue = [...pending]; // shallow copy

            const uploadWorker = async () => {
                while (queue.length > 0) {
                    const c = queue.shift();
                    if (!c) break;
                    let attempt = 0;
                    while (attempt < RETRIES) {
                        attempt++;
                        try {
                            await uploadChunk(uploadId!, c.index, c.blob);
                            // success
                            uploadedBytes += c.end - c.start;
                            const pct = Math.min(100, Math.round((uploadedBytes / totalBytes) * 100));
                            setLoaderProgress(10 + Math.round(pct * 0.85)); // scale to UI (10..95)
                            break;
                        } catch (err) {
                            console.warn(`Chunk ${c.index} attempt ${attempt} failed`, err);
                            if (attempt >= RETRIES) throw err;
                            // backoff
                            await new Promise((res) => setTimeout(res, 500 * attempt));
                        }
                    }
                }
            };

            // start worker pool
            const workers = new Array(Math.min(CONCURRENCY, pending.length)).fill(null).map(() => uploadWorker());
            await Promise.all(workers);

            // 4) complete
            setLoaderProgress(95);
            const completeResp = await completeUpload(uploadId);
            // handle response (adjust the key depending on your server)
            const finalPath = completeResp.data || completeResp;
            setUploadedvideopath(finalPath);
            setUploadedDuration(completeResp.duration || "");
            setUploadedSize(completeResp.size_mb || "");


            toast.success("File Uploaded Successfully!");

            // cleanup
            localStorage.removeItem(`upload_id:${file.name}`);
            setLoaderProgress(100);
        } catch (err) {
            console.error("Upload failed", err);
            toast.error("Error uploading video");
            setLoaderProgress(0);
            // do not remove stored upload_id so user can retry/resume
        } finally {
            setTimeout(() => setIsLoadingGetPage(false), 1000);
        }
    };




    useEffect(() => {

        setNewsLetter(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setCapturLeads(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setTwitternButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setFbButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setLinkedinButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setVideo(!!planDetails?.embed_youtube_video);

    }, [planDetails]);

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        setActiveItem(localStorage.getItem('activeItem') ? localStorage.getItem('activeItem') : itemName);
        localStorage.removeItem('campaignid');
        localStorage.removeItem('returningtocampaign');
        localStorage.removeItem('sourceurl');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('paymentOption');
        localStorage.removeItem('autoPublish');
        localStorage.removeItem('limitPublish');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('addTags');
        localStorage.removeItem('captureLeads');
        localStorage.removeItem('newsLetter');
        localStorage.removeItem('twitterBtn');
        localStorage.removeItem('fbBtn');
        localStorage.removeItem('pintrestBtn');
        localStorage.removeItem('linkedinBtn');
        localStorage.removeItem('video');
        localStorage.removeItem('twitterurl');
        localStorage.removeItem('fburl');
        localStorage.removeItem('pintresturl');
        localStorage.removeItem('linkedinurl');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('owndomain');
        localStorage.removeItem('ChangepayMode');
        localStorage.removeItem('IdChangingMode');
        localStorage.removeItem('PaymentSubscription');
        localStorage.removeItem('Authorurl');
        localStorage.removeItem('Authorname');
        localStorage.removeItem('authorDefaultCheck');
        localStorage.removeItem('videoTag');
        localStorage.removeItem('podcastUrl');
        localStorage.removeItem('sourcetext');

        if (itemName == 'createcontent') {
            navigate('/codegenie/new-podcast');
        }
        else if (itemName == 'createcourse') {
            navigate('/codegenie/new-course-2-1');
        } else if (itemName === 'course') {
            navigate('/codegenie/generated-courses');
        }
        else {
            navigate('/codegenie/generated-blogs');
        }

        if (itemName === 'upgrade') {
            /*  const value = {
                 _id: "",
                 product_name: "CodeGenie",
                 product_module: genieSelector.module ? genieSelector.module : "",
                 userid: "",
                 productid: ""
             };
             getProduct(value); */
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { campIdFromUpgrade: localStorage.getItem('campId') || ''/* selectedCampaign */, from_page: 'blog_listing' } });
        } else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            //console.log("loggedin:" + localStorage.getItem("logged_in"));
            dispatch(logout());
            var module = localStorage.getItem("module");


            toast.success("Logout success");
            // localStorage.removeItem("payment");
            localStorage.removeItem("msg");
            localStorage.removeItem("complexity");
            localStorage.removeItem("module");
            localStorage.removeItem("subscription_level");
            localStorage.removeItem("free_plan");
            // localStorage.removeItem("userRole");
            localStorage.removeItem("localStorage_msg");
            localStorage.removeItem("allSet");
            localStorage.removeItem("Blogs Generated");
            localStorage.removeItem("remaining_wish_count");
            localStorage.removeItem("userRole");
            localStorage.removeItem("payment");
            localStorage.removeItem("user_email");
            localStorage.removeItem("logged_in");
            localStorage.removeItem("prevImg");
            localStorage.removeItem("fromUpgrade");
            localStorage.removeItem("blogsCount");
            localStorage.removeItem("Generating Count");
            localStorage.removeItem("finalData");
            localStorage.removeItem("user_pass");
            localStorage.removeItem("fromNewcampaign");
            localStorage.removeItem("campaignid");
            localStorage.removeItem("returningtocampaign");
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('campId');
            localStorage.removeItem('campaignid');
            localStorage.removeItem('returningtocampaign');
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('smUrlpublish');
            localStorage.removeItem('addTags');
            localStorage.removeItem('captureLeads');
            localStorage.removeItem('newsLetter');
            localStorage.removeItem('twitterBtn');
            localStorage.removeItem('fbBtn');
            localStorage.removeItem('pintrestBtn');
            localStorage.removeItem('linkedinBtn');
            localStorage.removeItem('video');
            localStorage.removeItem('twitterurl');
            localStorage.removeItem('fburl');
            localStorage.removeItem('pintresturl');
            localStorage.removeItem('linkedinurl');
            localStorage.removeItem('owndomain');
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            localStorage.removeItem('user_name');
            localStorage.removeItem('refreshCount');
            localStorage.removeItem('publishingCampId');
            localStorage.removeItem('Authorurl');
            localStorage.removeItem('Authorname');
            localStorage.removeItem('authorDefaultCheck');
            localStorage.removeItem('appsumo_coupon_code');
            localStorage.removeItem('podcastUrl');
            localStorage.removeItem('AlertMessage');
            localStorage.removeItem('CreatingfromLanding');
            localStorage.removeItem('UrlfromLanding');
            localStorage.removeItem('signedup');
            localStorage.removeItem('uploadedvideo');
            localStorage.removeItem('uploadedVideoName');
            localStorage.removeItem('uploadStatus');
            localStorage.removeItem('editedposthashtags');
            localStorage.removeItem('editedpostblogsummary');
            localStorage.removeItem('editedpostblogtitle');
            localStorage.removeItem('editedposturl');
            localStorage.removeItem('user_email');
            localStorage.removeItem('YoutubeUrlfromLanding');
            localStorage.removeItem('FirstLogin');
            localStorage.removeItem('DirectSignup');
            localStorage.removeItem('FromIndexPage');
            localStorage.removeItem('activeItem');
            localStorage.removeItem('UpdateduserImage');
            localStorage.removeItem('publish_to_code_genie');
            localStorage.removeItem('publish_to_ocesha');
            localStorage.removeItem('competitor_search');
            localStorage.removeItem('FromEditBlog');
            localStorage.removeItem('ErrorAlert');
            localStorage.removeItem('FromSignIn');
            removeCookie('user_email');
            localStorage.clear();

            if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
                navigate("/Anycode_landing");
            else
                window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN||''; //"https://ocesha.ai";
        }
    };

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleTopicSelect = (topic: any) => {
        setSelectedTopic(topic);
    }

    const handleKeywordSelect = (keyword: any) => {
        setSelectedKeyword(keyword);
    }

    const audioItems: UploadedItem[] =
        course?.audio && course.audio.length > 0
            ? course.audio.map(
                (a: { name: string; duration: string }, index: number) => ({
                    label: `${a.name} – ${a.duration}`,
                    deletable: true,
                    index,
                })
            )
            : [
                {
                    label: "Audio not uploaded",
                    deletable: false,
                },
            ];


    const videoItems: UploadedItem[] =
        course?.video && course.video.length > 0
            ? course.video.map(
                (v: { name: string; duration: string }, index: number) => ({
                    label: `${v.name} – ${v.duration}`,
                    deletable: true,
                    index,
                })
            )
            : [
                {
                    label: "Video not uploaded",
                    deletable: false,
                },
            ];


    const documentItems: UploadedItem[] =
        course?.documents && course.documents.length > 0
            ? course.documents.map((d: { name: string; size: string }, index: number) => ({
                label: `${d.name} – ${d.size}`,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "Document file not uploaded",
                    deletable: false,
                },
            ];


    const youtubeItems =
        course?.youtube_urls && course.youtube_urls.length > 0
            ? course.youtube_urls.map((item: any, index: number) => ({
                label: item.url,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "YouTube URL not added",
                    deletable: false,
                },
            ];


    const webItems =
        course?.web_urls && course.web_urls.length > 0
            ? course.web_urls.map((item: any, index: number) => ({
                label: item.url,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "Web URL not added",
                    deletable: false,
                },
            ];


    const textDocItems =
        course?.text_documents && course.text_documents.length > 0
            ? course.text_documents.map((url: string, index: number) => ({
                label: url,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "Text Document not found",
                    deletable: false,
                },
            ];


    const mapToContentType = (prefix: string) => {
        switch (prefix) {
            case "https://":
                return "web";
            case "youtubeid":
                return "youtube";
            case "text":
                return "text";
            case "upload":
                return "video"; // or audio (based on file type)
            case "word":
            case "pdf":
                return "document";
            default:
                return "";
        }
    };






    const fetchCourseDetails = async (courseId: string) => {
        try {
            setLoading(true);

            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const { data } = await axios.post<GetCourseDetailsResponse>(
                `${apiUrl}/api/prompts/get_course_details`,
                { course_id: courseId }
            );

            if (data?.result?.expertise) {
                setExpertise(data.result.expertise); // ✅ pre-populate
            }
        } catch (error: any) {
            console.error("Failed to fetch course details", error);
            toast.error(
                error?.response?.data?.detail || "Failed to load course details"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleAddContent = async () => {
        const courseId = localStorage.getItem("course_id") || "";
        /* if (!courseId) {
            toast.error("Course not found");
            return;
        } */

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
        let contentType = mapToContentType(urlPrefix);


        let payloadValue: any = null;
        const file = uploadedFiles?.[0];

        if (urlPrefix === "text") {
            payloadValue = userBusinessText;
        }

        if (urlPrefix === "https://") {
            payloadValue = sourceUrl;
        }

        if (urlPrefix === "youtubeid") {
            payloadValue = sourceYoutubeUrl;
        }

        if (urlPrefix === "upload") {
            if (!uploadedvideopath) {
                toast.error("File not uploaded yet");
                return;
            }


            const detectedType = getUploadContentType(uploadedvideopath);
            if (!detectedType) {
                toast.error("Unsupported file type");
                return;
            }
            contentType = detectedType;


            payloadValue = {
                path: uploadedvideopath.split("###")[0],
                name: uploadedvideopath.split("###")[1],
                duration: uploadedDuration || "00:00",
                status: "pending",
                progress: 0
            };
        }

        if (urlPrefix === "word" || urlPrefix === "pdf") {
            if (!uploadedvideopath) {
                toast.error("File not uploaded yet");
                return;
            }

            payloadValue = {
                path: uploadedvideopath.split("###")[0],
                name: uploadedvideopath.split("###")[1],
                size: uploadedSize
            };

        }

        if (!payloadValue) {
            toast.error("No content to upload");
            return;
        }

        try {
            const user_email = localStorage.getItem("user_email") || "";
            const res = await axios.post(`${apiUrl}/api/prompts/create_course`, {
                user_email: user_email,
                course_id: courseId,
                content_type: contentType,
                content_value: payloadValue,
            });

            console.log('course creation res=>', res);
            localStorage.setItem("course_id", res?.data?.course_id);

            toast.success("Content added successfully");

            // refresh content
            fetchCourseDetails(courseId || res?.data?.course_id);

            // optional: clear state
            setUploadedFiles([]);
            setUploadedvideopath("");
            setSourceUrl("");
            setSourceYoutubeUrl("");
            setUserBusinessText("");
            resetUploadState();
            // Reset so the next addition can trigger again
            autoAddRef.current = false;

        } catch (err) {
            console.error(err);
            toast.error("Failed to add content");
            // Also reset on error so user can retry
            autoAddRef.current = false;
        }

        await fetchCourse();
    };

    const resetUploadState = () => {
        // reset dropdown
        setUrlPrefix("https://");

        // reset text inputs
        setSourceUrl("");
        setSourceYoutubeUrl("");
        setUserBusinessText("");

        // reset upload-related states
        setUploadedFiles([]);
        setUploadedvideopath("");
        setUploadedDuration("");
        setUploadedSize("");
        setUploadVideo("");

        // reset loaders
        setIsLoadingGetPage(false);
        setLoaderProgress(0);
        setLoadingText("");

        //  reset file input DOM value
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

        // ADD THIS — ensures auto-add effect can fire for next content
        autoAddRef.current = false;
    };

    const handleDeleteContent = async (
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text",
        index: number
    ) => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) {
            toast.error("Course not found");
            return;
        }

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

        try {
            await axios.post(`${apiUrl}/api/prompts/delete_course_content`, {
                course_id: courseId,
                content_type: contentType,
                index,
            });

            toast.success("Content removed");

            //  refresh UI instantly
            fetchCourse();
        } catch (err) {
            console.error(err);
            toast.error("Failed to remove content");
        }
    };

    const handleSourceSelect = (selectedValue: string) => {
        if (
            campDetails?.source !== 'upload' &&
            campDetails?.source !== 'youtube' &&
            campDetails?.source !== 'url' &&
            campDetails?.source !== 'text'
        ) {
            setUrlPrefix(selectedValue);

            switch (selectedValue) {
                case 'https://':
                    setSourceUrl('');
                    break;
                case 'youtubeid':
                    setSourceYoutubeUrl('');
                    break;
                case 'text':
                    setUserBusinessText('');
                    break;
                case 'upload':
                    break;
                default:
                    break;
            }
        }
    };

    // auto click 'Add Content' btn
    useEffect(() => {

        if (autoAddRef.current) return;

        /*const hasText =
            (urlPrefix === "text" || campDetails?.source === "text") &&
            !!userBusinessText?.trim();*/

        /*const hasUrl =
            (urlPrefix === "https://" || campDetails?.source === "url") &&
            !!sourceUrl?.trim();*/

        const hasYoutube =
            (urlPrefix === "youtubeid" || campDetails?.source === "youtube") &&
            !!sourceYoutubeUrl?.trim();

        const hasUpload =
            (urlPrefix === "upload" ||
                urlPrefix === "word" ||
                urlPrefix === "pdf") &&
            !!uploadedvideopath;

        //if (hasText || hasYoutube || hasUpload) {
        if (hasYoutube || hasUpload) {
            autoAddRef.current = true;
            handleAddContent();
        }

    }, [
        userBusinessText,
        sourceYoutubeUrl,
        uploadedvideopath,
        urlPrefix,
        campDetails?.source
    ]);

    // auto play intro(SPEAKER)
    const secondAudio =
        "https://texttospeachservice.ocesha.ai/media/21fa3445-8fc1-45ca-9b7a-7b3c44194b2a.wav";

    useEffect(() => {
        // Reset hasFetched if name wasn't available yet
        if (!userDetails?.first_name) return;
        if (hasFetched.current) return;

        hasFetched.current = true;
        fetchAudio();
    }, [userDetails?.first_name]); // fires whenever name becomes available

    useEffect(() => {
        const el = chatScrollRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
        });
    }, [chatMessages, isChatLoading]);

    const fetchAudio = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/speak?text=${encodeURIComponent(`Hi ${userDetails?.first_name}`)}`,
            );

            const data = res?.data;

            if (data?.audio_path) {
                playAudio(data.audio_path);
            }
        } catch (err) {
            console.log("Error fetching audio:", err);
        }
    };

    const playAudio = (url: string) => {
        const audio = new Audio(url);
        audioRef.current = audio;

        // Respect mute state
        audio.muted = isMuted;

        setCurrentAudioType("intro");

        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.catch((err) => {
                console.log("Autoplay blocked, waiting for user gesture:", err);
                // Retry on first user interaction
                const retryPlay = () => {
                    audio.play().catch(() => { });
                    document.removeEventListener("click", retryPlay);
                    document.removeEventListener("keydown", retryPlay);
                };
                document.addEventListener("click", retryPlay, { once: true });
                document.addEventListener("keydown", retryPlay, { once: true });
            });
        }

        audio.onended = () => {
            const nextAudio = new Audio(secondAudio);
            audioRef.current = nextAudio;
            nextAudio.muted = isMuted; // respect mute for second audio too
            nextAudio.play().catch(() => { });
            nextAudio.onended = () => {
                setCurrentAudioType(null);
            };
        };
    };

    const toggleMute = () => {
        setIsMuted((prev) => {
            const newState = !prev;

            if (audioRef.current) {
                if (newState) {
                    // MUTE → pause
                    audioRef.current.pause();
                } else {
                    // UNMUTE → resume
                    audioRef.current.play().catch(() => { });
                }
            }

            return newState;
        });
    };

    const steps = [
          "About You",
          "Content Sources",
          "Your Expertise",
          "Preferences",
        ];

    const activeStep = 3;

    const toneOptions = [
        "Helpful & Friendly",
        "Bold & Inspiring",
        "Professional & Clear",
        "Creative & Engaging",
    ];

    // useEffect(() => {
    //     console.log({
    //         isPlaying,
    //         isMuted,
    //         currentAudioType,
    //     });
    // }, [isPlaying, isMuted, currentAudioType]);

    const isSpeakerAnimating = (currentAudioType !== null || isPlaying) && !isMuted;  

    return (
        <>
            {/* <Header /> */}
            <div style={{ overflowX: 'hidden' }}>
                <div className="row">

                    <div className={FromSignUp === 'true' ? "col-sm-12 col-md-12 col-lg-12" : "col-sm-12 col-md-10 col-lg-10"} /* style={{ paddingRight: '2%' }} *//* style={{ margin: '7%' }} */>
                        {/* <Ocesha_header handleItemClick={handleItemClick} FromSignUp={FromSignUp} /> */}
                        {FromSignUp === 'true' ? <Divider sx={{ mt: 2 }} /> : <hr />}
                        <div className="overlay-container" style={{ paddingRight: FromSignUp === 'true' ? '10%' : undefined, paddingLeft: FromSignUp === 'true' ? '10%' : undefined }}>
                            <div style={{ width: '98%', marginBottom: '10%' }}>
                                {isloadingGetPage && !getPageError && (
                                    <div style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backdropFilter: 'blur(5px)',
                                        overflow: 'hidden',
                                    }}>

                                        <div style={{
                                            width: '80%', maxWidth: '700px',
                                            padding: '20px',
                                            backgroundColor: '#282C39',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                            textAlign: 'center'
                                        }}>
                                            <Typography style={{ fontSize: '30px' }}>{loadingText}{/* Generating Blogs with AI... */}</Typography>
                                            <br></br>
                                            {/* <LinearProgress /> */}
                                            <ProgressBar
                                                completed={loaderProgress}
                                                bgColor={loaderProgress >= 90 ? "#4CAF50" : "#4BA5EB"}
                                                height="20px"
                                                labelColor="#ffffff"
                                                labelAlignment="center"
                                            />
                                            <br></br>
                                            <Typography style={{ fontSize: '20px' }}>Sit tight while we upload your content.{/* a couple minutes */}...</Typography>
                                        </div>
                                    </div>
                                )}

                                {/* {(subscriptionFromCampList || planDetails?.mode == "Free Trial" || defaultPlanDetails?.mode == "Free Trial") ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ background: '#090619', borderRadius: '5px', padding: isMobile ? '6%' : '2%', width: isMobile ? '100%' : '50%', }}>
                                <Typography sx={{ fontSize: '15px', fontWeight: 'bolder', color: "#fff" }}><span style={{ display: 'flex', justifyContent: 'center', marginBottom: '2%' }}><InfoIcon style={{ color: 'Orange', fontSize: '30px' }} /></span><span>{(((planDetails?.subscription_level == 'level_3' || planDetails?.subscription_level == 'level_6') && planDetails?.mode == "Free Trial") || defaultPlanDetails?.mode == "Free Trial") ? 'Note: Traffic Hacker plan NOT ACTIVATED.  You can view this page but you will not be able to create new campaigns/update existing campaign with all features, until you have activated your Traffic Hacker plan.' : 'Note: You can view this page but you will not be able to create new campaigns until you upgrade to Traffic Hacker plan.'}</span></Typography>
                            </Box>
                        </Grid>
                    </Grid> : ''} */}

                                {planDetails?.payment_status === 'pending' ?
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box sx={{ background: '#090619', borderRadius: '5px', padding: isMobile ? '6%' : '2%', width: isMobile ? '100%' : '50%', }}>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 'bolder', color: "#fff" }}><span style={{ display: 'flex', justifyContent: 'center', marginBottom: '2%' }}><InfoIcon style={{ color: 'Orange', fontSize: '30px' }} /></span><span style={{ display: 'flex', justifyContent: 'center' }}>{'Note: Subscription is PENDING, please complete the payment.'}</span></Typography>
                                            </Box>
                                        </Grid>
                                    </Grid> : ''}

                                <div className="row gx-2">

                                    <div className="col-sm-12 col-md-4 col-lg-4 py-4" style={{ paddingLeft: '1.5rem' }}>


                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "block",
                                                width: "100%",
                                                overflow: "visible",
                                            }}
                                        >
                                            {/* Rohan image — no bump animation */}
                                            <Box
                                                component="img"
                                                src={RohanImg}
                                                alt="Rohan Hall"
                                                sx={{
                                                    position: "relative",
                                                    zIndex: 1,
                                                    width: "100%",
                                                    display: "block",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* Waveform bars — overlaid on the bottom of the image */}
                                            <Box
                                                sx={{
                                                    display: isSpeakerAnimating ? "flex" : "none",
                                                    position: "absolute",
                                                    left: 0,
                                                    right: 0,
                                                    bottom: "16px",          // distance from the bottom edge of the image
                                                    zIndex: 2,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "3px",
                                                    height: "48px",
                                                    px: 2,
                                                    pointerEvents: "none",   // so it doesn't block clicks on the image
                                                    background: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.35) 100%)",
                                                }}
                                            >
                                                {[
                                                    4, 10, 18, 8, 22, 14, 26, 6, 16, 30, 12, 20, 8, 24, 10, 18, 4, 14, 22, 8,
                                                    16, 28, 10, 20, 6, 24, 12, 18, 8, 14, 26, 10, 16, 22, 6, 20, 12, 8, 24, 14,
                                                ].map((peak, i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            width: "2.5px",
                                                            minWidth: "2.5px",
                                                            borderRadius: "2px",
                                                            background: "#3B82F6",
                                                            animation: `waveStrip${i} 1.1s ease-in-out infinite`,
                                                            animationDelay: `${(i % 10) * 0.08}s`,
                                                            [`@keyframes waveStrip${i}`]: {
                                                                "0%, 100%": { height: "6px" },
                                                                "50%": { height: `${peak}px` },
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </Box>

                                        <Paper
                                          sx={{
                                            background:
                                              "linear-gradient(180deg, rgba(11,12,20,1) 0%, rgba(10,14,28,1) 100%)",
                                            borderTopLeftRadius: 0,
                                            borderTopRightRadius: 0,
                                            borderBottomLeftRadius: "16px",
                                            borderBottomRightRadius: "16px",
                                            border: "1px solid rgba(255,255,255,0.08)",
                                            p: 3,
                                            mb: 2,
                                          }}
                                        >
                                          <Box position="relative"
                                          sx={{
                                              maxHeight: "300px", // fixed height
                                              overflowY: "auto",
                                              pr: 1, // space for scrollbar

                                              // Thin scrollbar
                                              "&::-webkit-scrollbar": {
                                                width: "4px",
                                              },
                                              "&::-webkit-scrollbar-track": {
                                                background: "transparent",
                                              },
                                              "&::-webkit-scrollbar-thumb": {
                                                background: "rgba(255,255,255,0.18)",
                                                borderRadius: "10px",
                                              },
                                              "&::-webkit-scrollbar-thumb:hover": {
                                                background: "rgba(255,255,255,0.3)",
                                              },

                                              // Firefox
                                              scrollbarWidth: "thin",
                                              scrollbarColor: "rgba(255,255,255,0.18) transparent",
                                            }}>

                                            {/* TOP LABEL */}
                                            <Typography
                                              sx={{
                                                fontSize: "11px",
                                                letterSpacing: "0.08em",
                                                color: "#4BA5EB",
                                                mb: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <AutoAwesomeIcon sx={{ fontSize: 18 }} /> MEET YOUR AI CONCIERGE
                                            </Typography>

                                            {/* TITLE */}
                                            <Typography
                                              sx={{
                                                color: "#fff",
                                                fontSize: "22px",
                                                fontWeight: 600,
                                                mb: 1.5,
                                              }}
                                            >
                                              Hi {userDetails?.first_name},
                                            </Typography>

                                            {/* DESCRIPTION */}
                                            <Typography
                                              sx={{
                                                color: "#A0AEC0",
                                                fontSize: "14px",
                                                lineHeight: "22px",
                                              }}
                                            >
                                              You're almost done!
                                              <br /><br />
                                              Choose the tone and style you want OceSha to use for your courses and content.
                                              <br /> <br />
                                              We'll apply it across:
                                            </Typography>

                                            <Box
                                                component="ul"
                                                sx={{
                                                    color: "#A0AEC0",
                                                    fontSize: "14px",
                                                    lineHeight: "22px",
                                                    pl: 3,
                                                    mt: 1,
                                                    mb: 0,
                                                    "& li": { mb: 0.5 },
                                                }}
                                                >
                                                <li>Courses & lessons</li>
                                                <li>AI teaching</li>
                                                <li>Blogs & social posts</li>
                                                <li>Marketing content</li>
 
                                            </Box>
                                            <br />

                                            <Typography
                                              sx={{
                                                color: "#A0AEC0",
                                                fontSize: "14px",
                                                lineHeight: "22px",
                                              }}
                                            >
                                              You can change this anytime.
      
                                            </Typography>
                                            

                                          </Box>
                                          {/* Divider */}
                                          <Box
                                            sx={{
                                              mt: 3,
                                              mb: 2,
                                              height: "1px",
                                              background: "rgba(255,255,255,0.08)",
                                            }}
                                          />

                                          {/* Header Row */}
                                          <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            sx={{ mb: 1 }}
                                          >
                                            <Typography sx={{ fontSize: "13px", color: "#D1D5DB" }}>
                                              Onboarding Progress
                                            </Typography>

                                            <Typography sx={{ fontSize: "13px", color: "#A0AEC0" }}>
                                              {activeStep + 1} of {steps.length}
                                            </Typography>
                                          </Stack>

                                          {/* Progress Bar */}
                                          <Box
                                            sx={{
                                              width: "100%",
                                              height: "6px",
                                              borderRadius: "10px",
                                              background: "rgba(255,255,255,0.1)",
                                              overflow: "hidden",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: `${((activeStep + 1) / steps.length) * 100}%`,
                                                height: "100%",
                                                borderRadius: "10px",
                                                background: "linear-gradient(90deg, #4BA5EB, #6C63FF)",
                                                transition: "width 0.3s ease",
                                              }}
                                            />
                                          </Box>
                                        </Paper>

                                        {/* Ask box */}
                                        <Paper sx={{ p: 2, background: "#2b2b32", borderRadius: "8px" }}>

                                            {/* Chat messages */}
                                            <Box
                                                ref={chatScrollRef}
                                                sx={{ maxHeight: 200, overflowY: "auto", mb: 1, scrollBehavior: "smooth" }}
                                                >
                                                {chatMessages.map((msg, i) => (
                                                    <Box key={i} sx={{ textAlign: msg.role === "user" ? "right" : "left", mb: 1 }}>
                                                        <Typography
                                                            sx={{
                                                                display: "inline-block",
                                                                px: 1.5,
                                                                py: 0.8,
                                                                borderRadius: 2,
                                                                background: msg.role === "user" ? "#4BA5EB" : "#000000",
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            {msg.role === "bot" ? (
                                                                <Box
                                                                    dangerouslySetInnerHTML={{ __html: msg.text }}
                                                                />
                                                            ) : (
                                                                msg.text
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {isChatLoading && (
                                                    <Typography sx={{ color: "#aaa", fontSize: 12 }}>
                                                        Thinking...
                                                    </Typography>
                                                )}
                                            </Box>

                                            {/* Input */}
                                            <TextareaAutosize
                                                value={questionText}
                                                onChange={(e) => setQuestionText(e.target.value)}
                                                placeholder="Ask AI anything..."
                                                minRows={2}
                                                style={{
                                                    width: "100%",
                                                    background: "#2b2b32",
                                                    color: "#fff",
                                                    border: "none",
                                                    outline: "none",
                                                }}
                                            />

                                            {/* Bottom actions */}
                                            <Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}>

                                                {/* SPEAKER (GLOBAL) */}
                                                {/* <TTSButton text={lastBotText} id="last-bot-message" /> */}
                                                <IconButton
                                                    onClick={toggleMute}
                                                    sx={{
                                                        background: isMuted
                                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                            : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",
                                                        borderRadius: "12px",
                                                        width: 45,
                                                        height: 45,
                                                        boxShadow: isMuted
                                                            ? "0 4px 15px rgba(102,126,234,0.5)"
                                                            : "0 4px 15px rgba(75,165,235,0.5)",
                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            transform: "scale(1.1)",
                                                            boxShadow: isMuted
                                                                ? "0 6px 20px rgba(102,126,234,0.7)"
                                                                : "0 6px 20px rgba(75,165,235,0.7)",
                                                        },
                                                        animation: !isMuted ? "speakerPulse 2s infinite" : "none",
                                                        "@keyframes speakerPulse": {
                                                            "0%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                            "50%": { boxShadow: "0 4px 25px rgba(75,165,235,0.9)" },
                                                            "100%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                        },
                                                    }}
                                                >
                                                    {isMuted ? (
                                                        <VolumeOffIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    ) : (
                                                        <VolumeUpIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    )}
                                                </IconButton>

                                                {/* MIC */}
                                                {/* <IconButton onClick={handleMicClick}>
                                                    <MicNoneOutlinedIcon sx={{ color: "#fff" }} />
                                                </IconButton> */}
                                                <IconButton
                                                    // onClick={handleMicClick}
                                                    //onClick={() => handleMic(recognitionRef, isListening, setIsListening)}
                                                    onClick={() =>
                                                        isRecording
                                                            ? stopRecording()
                                                            : startRecording()
                                                    }
                                                    className={ isRecording ? "recording-mic-btn" : "mic-btn" }
                                                >
                                                    <MicNoneOutlinedIcon sx={{ color: "#fff", fontSize: "20px", }} />
                                                </IconButton>

                                                {/* SEND */}
                                                <IconButton onClick={() => getChatBotResponse(questionText)}>
                                                    <SendIcon sx={{ color: "#fff" }} />
                                                </IconButton>

                                            </Stack>
                                        </Paper>
                                    </div>

                                    <div className="col-md-8">
                                        <Box sx={{ px: { xs: 2, md: 4 }, pl: { md: 2 }, py: 2 }}>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                cursor: "pointer",
                                                mb: 2,
                                                width: "fit-content"
                                              }}
                                              onClick={() => navigate(-1)}
                                            >
                                              <ArrowBackIcon sx={{ fontSize: 20 }} />
                                              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                                                Back
                                              </Typography>
                                            </Box>

                                            {/* ===== Step Indicator ===== */}
                                            <Box sx={{ maxWidth: "500px", mx: "auto", px: 2 }}>
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  sx={{ width: "100%", mb: 4 }}
                                                >
                                                  {steps.map((label, index) => {

                                                    const isActive = index === activeStep;
                                                    const isCompleted = index < activeStep;

                                                    return (
                                                      <React.Fragment key={index}>

                                                        <Stack alignItems="center" spacing={1}>

                                                          {/* Circle */}
                                                          <Box
                                                            sx={{
                                                              width: 36,
                                                              height: 36,
                                                              borderRadius: "50%",
                                                              display: "flex",
                                                              alignItems: "center",
                                                              justifyContent: "center",
                                                              fontSize: "14px",
                                                              fontWeight: 600,
                                                              color: "#fff",

                                                              background:
                                                                isActive || isCompleted
                                                                  ? "linear-gradient(90deg, #4BA5EB, #6C63FF)"
                                                                  : "transparent",

                                                              border:
                                                                isActive || isCompleted
                                                                  ? "none"
                                                                  : "1px solid rgba(255,255,255,0.2)",
                                                            }}
                                                          >
                                                            {isCompleted ? (
                                                              <CheckIcon sx={{ fontSize: 18 }} />
                                                            ) : (
                                                              index + 1
                                                            )}
                                                          </Box>

                                                          {/* Label */}
                                                          <Typography
                                                            sx={{
                                                              fontSize: "12px",
                                                              color:
                                                                isActive || isCompleted
                                                                  ? "#fff"
                                                                  : "#A0AEC0",
                                                            }}
                                                          >
                                                            {label}
                                                          </Typography>
                                                        </Stack>

                                                        {/* Connector */}
                                                        {index !== steps.length - 1 && (
                                                          <Box
                                                            sx={{
                                                              flex: 1,
                                                              height: "1px",
                                                              mx: 0,
                                                              mt: "-18px",

                                                              background:
                                                                index < activeStep - 1
                                                                  ? "repeating-linear-gradient(to right, #4BA5EB 0 3px, transparent 3px 6px)"
                                                                  : "repeating-linear-gradient(to right, rgba(255,255,255,0.3) 0 3px, transparent 3px 6px)",
                                                            }}
                                                          />
                                                        )}
                                                      </React.Fragment>
                                                    );
                                                  })}
                                                </Stack>
                                            </Box>

                                            <Typography
                                              sx={{
                                                textAlign: "center",
                                                fontSize: { xs: "22px", md: "32px" },
                                                fontWeight: 700,
                                                color: "#fff",
                                                lineHeight: 1.3,
                                                mb: 1.5
                                              }}
                                            >
                                              How would you like your{" "}
                                              <span
                                                style={{
                                                  background: "linear-gradient(90deg, #4BA5EB, #6C63FF)",
                                                  WebkitBackgroundClip: "text",
                                                  WebkitTextFillColor: "transparent"
                                                }}
                                              >
                                                courses & content
                                              </span>{" "}
                                              to sound?
                                            </Typography>

                                            <Typography
                                              sx={{
                                                textAlign: "center",
                                                fontSize: "14px",
                                                color: "#A0AEC0",
                                                maxWidth: "600px",
                                                mx: "auto",
                                                lineHeight: 1.6
                                              }}
                                            >
                                              Choose the tone you want OceSha to use when creating your courses, lessons,
                                              and marketing content.
                                            </Typography>
                                            {/* Preference Cards Section */}
                                            <Box sx={{ mt: 5 }}>
                                                <Grid container spacing={2.5}>
                                                    {[
                                                        {
                                                            title: "Helpful & Friendly",
                                                            description:
                                                                "Warm, approachable, and easy to understand. Great for building trust and educating.",
                                                            tags: ["Education", "Coaching"],
                                                            color: "#4CAF50",
                                                            icon: "😊",
                                                        },
                                                        {
                                                            title: "Bold & Inspiring",
                                                            description:
                                                                "Motivational, confident, and action-oriented. Great for driving change and inspiring.",
                                                            tags: ["Leadership", "Motivation"],
                                                            color: "#8B5CF6",
                                                            icon: "🚀",
                                                        },
                                                        {
                                                            title: "Professional & Clear",
                                                            description:
                                                                "Direct, credible, and data-informed. Great for explaining complex topics.",
                                                            tags: ["Business", "Thought Leadership"],
                                                            color: "#3B82F6",
                                                            icon: "📊",
                                                        },
                                                        {
                                                            title: "Creative & Engaging",
                                                            description:
                                                                "Imaginative, story-driven, and attention-grabbing. Great for brainstorming and ideas.",
                                                            tags: ["Creative", "Innovation"],
                                                            color: "#F59E0B",
                                                            icon: "💡",
                                                        },
                                                    ].map((card, index) => {
                                                        const isSelected = selectedPreference === index;

                                                        return (
                                                            <Grid item xs={12} sm={6} md={3} key={index}>
                                                                <Box
                                                                    onClick={() => setSelectedPreference(index)}
                                                                    sx={{
                                                                        position: "relative",
                                                                        height: "100%",
                                                                        minHeight: "300px",
                                                                        borderRadius: "18px",
                                                                        p: 3,
                                                                        cursor: "pointer",
                                                                        transition: "all 0.25s ease",
                                                                        border: isSelected
                                                                            ? "1.5px solid #3B82F6"
                                                                            : "1px solid rgba(255,255,255,0.08)",

                                                                        background:
                                                                            "linear-gradient(180deg, rgba(14,22,40,0.95) 0%, rgba(10,14,24,0.98) 100%)",

                                                                        boxShadow: isSelected
                                                                            ? "0 0 25px rgba(59,130,246,0.22)"
                                                                            : "none",

                                                                        "&:hover": {
                                                                            transform: "translateY(-4px)",
                                                                            border: "1px solid rgba(75,165,235,0.45)",
                                                                            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                                                                        },
                                                                    }}
                                                                >
                                                                    {/* Top Radio */}
                                                                    <Box
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 16,
                                                                            right: 16,
                                                                            width: 18,
                                                                            height: 18,
                                                                            borderRadius: "50%",
                                                                            border: isSelected
                                                                                ? "5px solid #3B82F6"
                                                                                : "2px solid rgba(255,255,255,0.35)",
                                                                            background: isSelected
                                                                                ? "#fff"
                                                                                : "transparent",
                                                                            transition: "all 0.2s ease",
                                                                        }}
                                                                    />

                                                                    {/* Icon */}
                                                                    <Box
                                                                        sx={{
                                                                            width: 72,
                                                                            height: 72,
                                                                            borderRadius: "50%",
                                                                            background: card.color,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: "32px",
                                                                            mb: 3,
                                                                            mx: "auto",
                                                                            boxShadow: `0 0 30px ${card.color}55`,
                                                                        }}
                                                                    >
                                                                        {card.icon}
                                                                    </Box>

                                                                    {/* Title */}
                                                                    <Typography
                                                                        sx={{
                                                                            color: "#fff",
                                                                            fontSize: "18px",
                                                                            fontWeight: 700,
                                                                            textAlign: "center",
                                                                            mb: 1.5,
                                                                        }}
                                                                    >
                                                                        {card.title}
                                                                    </Typography>

                                                                    {/* Description */}
                                                                    <Typography
                                                                        sx={{
                                                                            color: "rgba(255,255,255,0.68)",
                                                                            fontSize: "14px",
                                                                            lineHeight: 1.7,
                                                                            textAlign: "center",
                                                                            mb: 3,
                                                                            minHeight: "90px",
                                                                        }}
                                                                    >
                                                                        {card.description}
                                                                    </Typography>

                                                                    {/* Best For */}
                                                                    <Typography
                                                                        sx={{
                                                                            color: "#3B82F6",
                                                                            fontSize: "13px",
                                                                            fontWeight: 600,
                                                                            textAlign: "center",
                                                                            mb: 1.5,
                                                                        }}
                                                                    >
                                                                        Best for:
                                                                    </Typography>

                                                                    {/* Tags */}
                                                                    <Stack
                                                                        direction="row"
                                                                        spacing={1}
                                                                        justifyContent="center"
                                                                        flexWrap="wrap"
                                                                        useFlexGap
                                                                    >
                                                                        {card.tags.map((tag, tagIndex) => (
                                                                            <Box
                                                                                key={tagIndex}
                                                                                sx={{
                                                                                    px: 1.5,
                                                                                    py: 0.7,
                                                                                    borderRadius: "999px",
                                                                                    background: "rgba(255,255,255,0.05)",
                                                                                    border:
                                                                                        "1px solid rgba(255,255,255,0.08)",
                                                                                }}
                                                                            >
                                                                                <Typography
                                                                                    sx={{
                                                                                        color: "rgba(255,255,255,0.7)",
                                                                                        fontSize: "11px",
                                                                                        fontWeight: 500,
                                                                                    }}
                                                                                >
                                                                                    {tag}
                                                                                </Typography>
                                                                            </Box>
                                                                        ))}
                                                                    </Stack>
                                                                </Box>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>

                                                {/* Bottom Info Box */}
                                                <Box
                                                    sx={{
                                                        mt: 3,
                                                        borderRadius: "14px",
                                                        border: "1px solid rgba(255,255,255,0.08)",
                                                        background: "rgba(255,255,255,0.02)",
                                                        px: 3,
                                                        py: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        flexWrap: "wrap",
                                                        gap: 2,
                                                    }}
                                                >
                                                    <Stack direction="row" spacing={1.5} alignItems="center">
                                                        <AutoAwesomeIcon sx={{ color: "#4BA5EB" }} />

                                                        <Box>
                                                            <Typography
                                                                sx={{
                                                                    color: "#fff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                Don’t worry, you can always change this later.
                                                            </Typography>

                                                            <Typography
                                                                sx={{
                                                                    color: "rgba(255,255,255,0.6)",
                                                                    fontSize: "13px",
                                                                }}
                                                            >
                                                                We'll adapt the tone as we learn more about you.
                                                            </Typography>
                                                        </Box>
                                                    </Stack>

                                                    {/*<Button
                                                        variant="outlined"
                                                        startIcon={<AutoAwesomeIcon />}
                                                        sx={{
                                                            borderRadius: "10px",
                                                            textTransform: "none",
                                                            color: "#4BA5EB",
                                                            borderColor: "rgba(75,165,235,0.35)",
                                                            px: 2,
                                                            py: 1,

                                                            "&:hover": {
                                                                borderColor: "#4BA5EB",
                                                                background: "rgba(75,165,235,0.08)",
                                                            },
                                                        }}
                                                    >
                                                        Customize more
                                                    </Button> */}
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                            width: "96%",
                                            mt: 2,
                                          }}
                                        >
                                          {/* Buttons Row */}
                                          <Stack direction="row" alignItems="center" spacing={1}>

                                            {/* Previous Button */}
                                            <Button
                                              variant="outlined"
                                              onClick={() => {
                                                handleCreateCourseStepPrevious();
                                              }}
                                              sx={{
                                                height: "42px",
                                                px: 3,
                                                borderRadius: "8px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "#D1D5DB",
                                                borderColor: "rgba(255,255,255,0.12)",

                                                "&:hover": {
                                                  borderColor: "#3B82F6",
                                                  background: "rgba(59,130,246,0.06)",
                                                },

                                                "& .MuiButton-startIcon": {
                                                  marginRight: "4px",
                                                },
                                              }}
                                              startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
                                            >
                                              Previous
                                            </Button>

                                            {/* Complete Button */}
                                            <Button
                                              variant="contained"
                                              onClick={() => {
                                                if (audioRef.current) {
                                                  audioRef.current.pause();
                                                  audioRef.current.currentTime = 0;
                                                }

                                                handleCreateCourseStep2();
                                              }}
                                              sx={{
                                                height: "42px",
                                                px: 3,
                                                borderRadius: "8px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                color: "#fff",
                                                minWidth: "170px",

                                                background:
                                                  "linear-gradient(90deg, #3B82F6 0%, #2563EB 100%)",

                                                boxShadow: "0 4px 18px rgba(59,130,246,0.35)",

                                                "&:hover": {
                                                  background:
                                                    "linear-gradient(90deg, #2563EB 0%, #1D4ED8 100%)",
                                                },
                                              }}
                                            >
                                              Complete Setup ✨
                                            </Button>
                                          </Stack>

                                          {/* Helper Text */}
                                          <Stack
                                            direction="row"
                                            spacing={0.7}
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{
                                              mt: 1,
                                              mr: 1,
                                              opacity: 0.7,
                                            }}
                                          >
                                            <AccessTimeIcon
                                              sx={{
                                                fontSize: 14,
                                                color: "#94A3B8",
                                              }}
                                            />

                                            <Typography
                                              sx={{
                                                color: "#94A3B8",
                                                fontSize: "12px",
                                              }}
                                            >
                                              Setup takes less than 2 minutes
                                            </Typography>
                                          </Stack>
                                        </Box>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div >
                </div>
            </div >

            <Modal
                open={openpaymentInstructModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 600,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    {/* <Typography sx={{ fontSize: '25px' }}>ThankYou!</Typography> */}
                    <PriorityHighIcon style={{ color: 'yellow', fontSize: '38px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center'/* , fontSize: 'xx-large', marginTop: '22px' */ }}>Please make a payment to complete your process.</p>
                    <Stack flexDirection="row">
                        <Button
                            onClick={handleModalPayNowClick}
                            variant="contained"
                            sx={{ mr: 2 }}
                        >
                            Pay Now
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={openGetPagesuccessModal}
                onClose={() => setOpenGetPageSuccessModal(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 600,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    <TaskAltIcon style={{ color: 'green', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center' }}>We have generated your first blogs. We will automatically generate new blogs daily per your selected plan.  You can edit each blog from the My Blog page with the Edit button and Export the blogs to social media or blogging platforms with the Export button.  Use the Help button on each page to learn more.</p>
                    <Stack flexDirection="row">
                        {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}

                        <Button
                            onClick={handleGetPageModalClose}
                            variant="contained"
                            sx={{ mr: 2 }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={confirmCancelSubscription}
                onClose={() => setConfirmCancelSubscription(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 800,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    <InfoIcon style={{ color: 'Orange', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center', color: '#fff' }}>When you cancel your subscription you are also canceling the hosting of your blog pages.  If you would like to keep this content, please copy the content to use on a different platform.  Once cancelled the content will be archived for 30 days then it will be deleted from the Traffic Monster servers and from Google Indexing.</p>
                    <Stack flexDirection="row" sx={{ gap: '10px', marginTop: '2%' }}>
                        {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}
                        <Button
                            onClick={handleCancelSubscriptionClick}
                            variant="contained"
                            sx={{ /* mr: 2, */ fontWeight: 'bolder', fontSize: '17px' }}
                        >
                            {cancellingLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Continue'}
                        </Button>
                        <Button
                            onClick={() => setConfirmCancelSubscription(false)}
                            variant="contained"
                            sx={{ /* mr: 2, */ fontWeight: 'bolder', fontSize: '17px' }}
                        >
                            Exit
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={upgradeModal}
                /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "40%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}><InfoIcon sx={{ color: '#ffcc00' }} /><br />
                        {((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) || ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) ? 'Blog count exceeds your plan limit. Please upgrade your plan to continue.' : 'This feature is not included in your plan.  Please upgrade to have access to this feature.'}</Typography>

                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>

                        {/* <Button
                            variant="contained"
                            onClick={() => {
                                const value = {
                                    _id: "",
                                    product_name: "CodeGenie",
                                    product_module: genieSelector.module ? genieSelector.module : "",
                                    userid: "",
                                    productid: ""
                                };
                                getProduct(value);
                                localStorage.setItem('fromUpgrade', 'true');
                                navigate('/pricing');
                            }}>
                            Upgrade
                        </Button> */}

                        <Button
                            onClick={() => setUpgradeModal(false)}
                            variant="contained"
                        // sx={{ mr: 2, marginTop: '15%' }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={helperPopup}
                /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "70%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    {/* <video
                        controls
                        style={{ width: '100%' }}
                        src={helpervideosrc}
                        autoPlay
                    /> */}
                    <iframe
                        width="100%"
                        height="500"
                        src={helpervideosrc}
                        title="Help Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                    <Stack flexDirection="row">
                        <Button
                            onClick={() => setHelperPopup(false)}
                            variant="contained"
                            sx={{ mr: 2, marginTop: '15%' }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={topicsList}
                // onClose={() => setTopicsList(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70%", // Adjusted width for responsiveness
                    maxWidth: 1000,
                    bgcolor: "#36393F",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    height: '85%',
                    maxHeight: '110vh',
                    overflow: 'auto',
                    borderRadius: '8px',
                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Blog Topics</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some suggested topics to write about. You can also give us a different topic below.  Our AI will write about this topic using the content you provided.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Box sx={{
                            maxHeight: '38vh',
                            overflowY: 'auto',
                            marginTop: '1%'
                        }}>
                            <RadioGroup value={selectedTopic} onChange={(e) => handleTopicSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {topics && topics?.map((topic: any, index: any) => (
                                        <Grid item xs={12} lg={12} style={{ padding: '0.5%', height: '50px' }} key={index}>
                                            <Button
                                                fullWidth
                                                color="primary"
                                                sx={{
                                                    textAlign: 'left',
                                                    bgcolor: selectedTopic === topic ? '#0168B5' : 'transparent',
                                                    color: selectedTopic === topic ? '#fff' : '#CBCBCB',
                                                    borderColor: '#CBCBCB',
                                                    '&:hover': { bgcolor: '#0168B5', color: '#fff' },
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    // minHeight: '30px'
                                                }}
                                                onClick={() => handleTopicSelect(topic)}
                                            >
                                                <Radio
                                                    checked={selectedTopic === topic}
                                                    value={topic}
                                                    sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }}
                                                />
                                                {topic.replace(/-/g, ' ')}
                                            </Button>
                                        </Grid>
                                    ))}
                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            // label="Selected Topic"
                            value={selectedTopic}
                            onChange={(e) => setSelectedTopic(e.target.value)}
                            // InputProps={{ readOnly: true }}
                            sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }}
                            placeholder="Input your topic here"
                        />
                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                            <Button
                                variant="contained"
                                // color="primary"
                                disabled={!selectedTopic}
                                // onClick={() => handleGetPageforCampaign(campaignId, selectedTopic)}
                                onClick={() => handleTopicConfirmation(selectedTopic, 10, campaignId)}
                                sx={{ color: '#fff' }}
                            >
                                {isKeywordLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Continue'}
                            </Button>
                        </Stack>

                    </Stack>
                </Box>
            </Modal>

            <Modal open={keywordsList}
                // onClose={() => setTopicsList(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70%",
                    maxWidth: 1000,
                    bgcolor: "#36393F",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    height: '87%',
                    maxHeight: '110vh',
                    overflow: 'auto',
                    borderRadius: '8px',
                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Keyword Suggestions</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some keywords that we suggest could help you with traffic for your blog.   Pick one or add your own.  Keep in mind that the higher the potential traffic the more difficult it may be for your blog to rank high in google search results.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />

                        <Box sx={{
                            maxHeight: '38vh',
                            overflowY: 'auto',
                            marginTop: '1%'
                        }}>
                            <RadioGroup value={selectedKeyword} onChange={(e) => handleKeywordSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {keywords && keywords.length > 0 ? (
                                        <Table sx={{ width: '100%', padding: '1%' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Select</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Keyword</TableCell>
                                                    {/* <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Potential Traffic</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {keywords.map((keyword: any, index: any) => (
                                                    <TableRow key={index} sx={{ '&:hover': { bgcolor: '#0168B5', color: '#fff' }, bgcolor: selectedKeyword === keyword.keyword ? '#0168B5' : 'transparent' }}>
                                                        <TableCell sx={{ borderBottom: '1px solid #CBCBCB' }}>
                                                            <Radio
                                                                checked={selectedKeyword === keyword.keyword}
                                                                value={keyword.keyword}
                                                                onChange={() => handleKeywordSelect(keyword.keyword)}
                                                                sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.keyword}
                                                        </TableCell>
                                                        {/* <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.potentical_traffic}
                                                        </TableCell> */}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    ) : (
                                        <div className="alert alert-info" role="alert">
                                            Keyword search failed, Please try again.
                                        </div>
                                    )}

                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            // label="Selected Topic"
                            value={selectedKeyword}
                            onChange={(e) => setSelectedKeyword(e.target.value)}
                            // InputProps={{ readOnly: true }}
                            sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }}
                            placeholder="Input your keyword here"
                        />
                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                            <Button
                                variant="contained"
                                onClick={() => handleTopicConfirmation(selectedTopic, 10, campaignId)}
                                sx={{ color: '#fff' }}
                            >
                                {isKeywordLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Retry'}
                            </Button>
                            <Button
                                variant="contained"
                                // color="primary"
                                disabled={!selectedKeyword}
                                sx={{ color: '#fff' }}
                                onClick={() => handleGetPageforCampaign(user_email, campaignId, selectedTopic, selectedKeyword)}
                            >
                                Confirm
                            </Button>
                        </Stack>

                    </Stack>
                </Box>
            </Modal>


            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle>Delete content?</DialogTitle>

                <DialogContent>
                    <Typography>
                        Are you sure you want to delete this content? This action cannot be undone.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                            if (deleteArgs) {
                                handleDeleteContent(deleteArgs.contentType, deleteArgs.index);
                            }
                            setConfirmOpen(false);
                            setDeleteArgs(null);
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}



export default New_Course_4;